package generated
import BlockData
import BlockSize
import GridSize
val data=listOf(BlockData(
	typeId="OxygenTank",
	xsiType="GasTank",
	subtypeId="OxygenTankSmall",
	humanName="Oxygen Tank",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=641.6,
	pcu=25,
	components=mapOf("SteelPlate" to 16, "LargeTube" to 8, "SmallTube" to 10, "Computer" to 8, "Construction" to 10)
), BlockData(
	typeId="OxygenTank",
	xsiType="GasTank",
	subtypeId="",
	humanName="Oxygen Tank",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=3161.6,
	pcu=25,
	components=mapOf("SteelPlate" to 80, "LargeTube" to 40, "SmallTube" to 60, "Computer" to 8, "Construction" to 40)
), BlockData(
	typeId="OxygenTank",
	xsiType="GasTank",
	subtypeId="LargeHydrogenTank",
	humanName="Hydrogen Tank",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=8161.6,
	pcu=25,
	components=mapOf("SteelPlate" to 280, "LargeTube" to 80, "SmallTube" to 60, "Computer" to 8, "Construction" to 40)
), BlockData(
	typeId="OxygenTank",
	xsiType="GasTank",
	subtypeId="LargeHydrogenTankSmall",
	humanName="Small Hydrogen Tank",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=3161.6,
	pcu=25,
	components=mapOf("SteelPlate" to 80, "LargeTube" to 40, "SmallTube" to 60, "Computer" to 8, "Construction" to 40)
), BlockData(
	typeId="OxygenTank",
	xsiType="GasTank",
	subtypeId="SmallHydrogenTank",
	humanName="Hydrogen Tank",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 5, 5),
	mass=1580.8,
	pcu=25,
	components=mapOf("SteelPlate" to 40, "LargeTube" to 20, "SmallTube" to 30, "Computer" to 4, "Construction" to 20)
), BlockData(
	typeId="OxygenTank",
	xsiType="GasTank",
	subtypeId="SmallHydrogenTankSmall",
	humanName="Small Hydrogen Tank",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 2, 1),
	mass=109.8,
	pcu=25,
	components=mapOf("SteelPlate" to 3, "LargeTube" to 1, "SmallTube" to 2, "Computer" to 4, "Construction" to 2)
), BlockData(
	typeId="AirVent",
	xsiType="AirVent",
	subtypeId="",
	humanName="Air Vent",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1001.0,
	pcu=10,
	components=mapOf("SteelPlate" to 30, "Construction" to 20, "Motor" to 10, "Computer" to 5)
), BlockData(
	typeId="AirVent",
	xsiType="AirVent",
	subtypeId="AirVentFull",
	humanName="Air Vent Full",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1381.0,
	pcu=10,
	components=mapOf("SteelPlate" to 45, "Construction" to 30, "Motor" to 10, "Computer" to 5)
), BlockData(
	typeId="AirVent",
	xsiType="AirVent",
	subtypeId="SmallAirVent",
	humanName="Air Vent",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=189.0,
	pcu=10,
	components=mapOf("SteelPlate" to 3, "Construction" to 10, "Motor" to 2, "Computer" to 5)
), BlockData(
	typeId="AirVent",
	xsiType="AirVent",
	subtypeId="SmallAirVentFull",
	humanName="Air Vent Full",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=269.0,
	pcu=10,
	components=mapOf("SteelPlate" to 5, "Construction" to 15, "Motor" to 2, "Computer" to 5)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="SmallBlockSmallContainer",
	humanName="Small Cargo Container",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=49.2,
	pcu=10,
	components=mapOf("InteriorPlate" to 3, "Construction" to 1, "Computer" to 1, "Motor" to 1, "Display" to 1)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="SmallBlockMediumContainer",
	humanName="Medium Cargo Container",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=274.8,
	pcu=10,
	components=mapOf("InteriorPlate" to 30, "Construction" to 10, "Computer" to 4, "Motor" to 4, "Display" to 1)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="SmallBlockLargeContainer",
	humanName="Large Cargo Container",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 5, 5),
	mass=626.2,
	pcu=10,
	components=mapOf("InteriorPlate" to 75, "Construction" to 25, "Computer" to 6, "Motor" to 8, "Display" to 1)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="LargeBlockSmallContainer",
	humanName="Small Cargo Container",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=648.4,
	pcu=10,
	components=mapOf("InteriorPlate" to 40, "Construction" to 40, "MetalGrid" to 4, "SmallTube" to 20, "Motor" to 4, "Display" to 1, "Computer" to 2)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="LargeBlockLargeContainer",
	humanName="Large Cargo Container",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=2593.6,
	pcu=10,
	components=mapOf("InteriorPlate" to 360, "Construction" to 80, "MetalGrid" to 24, "SmallTube" to 60, "Motor" to 20, "Display" to 1, "Computer" to 8)
), BlockData(
	typeId="Conveyor",
	subtypeId="SmallBlockConveyor",
	humanName="Small Conveyor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=68.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 4, "Construction" to 4, "Motor" to 1)
), BlockData(
	typeId="Conveyor",
	subtypeId="SmallBlockConveyorConverter",
	humanName="Conveyor Converter",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 1),
	mass=154.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 6, "Construction" to 8, "SmallTube" to 6, "Motor" to 2)
), BlockData(
	typeId="Conveyor",
	subtypeId="LargeBlockConveyor",
	humanName="Conveyor Junction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=524.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "SmallTube" to 20, "Motor" to 6)
), BlockData(
	typeId="Collector",
	xsiType="PoweredCargoContainer",
	subtypeId="Collector",
	humanName="Collector",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1574.0,
	pcu=25,
	components=mapOf("SteelPlate" to 45, "Construction" to 50, "SmallTube" to 12, "Motor" to 8, "Display" to 4, "Computer" to 10)
), BlockData(
	typeId="Collector",
	xsiType="PoweredCargoContainer",
	subtypeId="CollectorSmall",
	humanName="Collector",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=1237.6,
	pcu=25,
	components=mapOf("SteelPlate" to 35, "Construction" to 35, "SmallTube" to 12, "Motor" to 8, "Display" to 2, "Computer" to 8)
), BlockData(
	typeId="ShipConnector",
	xsiType="ShipConnector",
	subtypeId="Connector",
	humanName="Connector",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=3564.0,
	pcu=125,
	components=mapOf("SteelPlate" to 150, "Construction" to 40, "SmallTube" to 12, "Motor" to 8, "Computer" to 20)
), BlockData(
	typeId="ShipConnector",
	xsiType="ShipConnector",
	subtypeId="ConnectorSmall",
	humanName="Small Connector",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=204.8,
	pcu=125,
	components=mapOf("SteelPlate" to 7, "Construction" to 4, "SmallTube" to 2, "Motor" to 1, "Computer" to 4)
), BlockData(
	typeId="ShipConnector",
	xsiType="ShipConnector",
	subtypeId="ConnectorMedium",
	humanName="Connector",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 2),
	mass=685.2,
	pcu=125,
	components=mapOf("SteelPlate" to 21, "Construction" to 12, "SmallTube" to 6, "Motor" to 6, "Computer" to 6)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorTube",
	humanName="Conveyor Tube",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=394.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 14, "Construction" to 20, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorTubeDuct",
	humanName="Reinforced Conveyor Tube",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=894.0,
	pcu=10,
	components=mapOf("SteelPlate" to 25, "InteriorPlate" to 14, "Construction" to 20, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorTubeDuctCurved",
	humanName="Reinforced Curved Conveyor Tube",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=894.0,
	pcu=10,
	components=mapOf("SteelPlate" to 25, "InteriorPlate" to 14, "Construction" to 20, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="Conveyor",
	subtypeId="ConveyorTubeDuctT",
	humanName="Reinforced Conveyor Tube T Junction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=880.0,
	pcu=10,
	components=mapOf("SteelPlate" to 22, "InteriorPlate" to 16, "Construction" to 24, "SmallTube" to 14, "Motor" to 6)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorTubeSmall",
	humanName="Small Conveyor Tube",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=35.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 1, "Motor" to 1, "Construction" to 1)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorTubeDuctSmall",
	humanName="Small Reinforced Conveyor Tube",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=75.0,
	pcu=10,
	components=mapOf("SteelPlate" to 2, "InteriorPlate" to 1, "Motor" to 1, "Construction" to 1)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorTubeDuctSmallCurved",
	humanName="Small Reinforced Curved Conveyor Tube",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=75.0,
	pcu=10,
	components=mapOf("SteelPlate" to 2, "InteriorPlate" to 1, "Motor" to 1, "Construction" to 1)
), BlockData(
	typeId="Conveyor",
	subtypeId="ConveyorTubeDuctSmallT",
	humanName="Small Reinforced Conveyor Tube T Junction",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=86.0,
	pcu=10,
	components=mapOf("SteelPlate" to 2, "InteriorPlate" to 2, "Motor" to 1, "Construction" to 2)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorTubeMedium",
	humanName="Medium Conveyor Tube",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=374.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 10, "Construction" to 20, "SmallTube" to 10, "Motor" to 6)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorFrameMedium",
	humanName="Conveyor Frame",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 3, 3),
	mass=179.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 5, "Construction" to 12, "SmallTube" to 5, "Motor" to 2)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorTubeCurved",
	humanName="Curved Conveyor Tube",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=394.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 14, "Construction" to 20, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorTubeSmallCurved",
	humanName="Small Curved Conveyor Tube",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=35.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 1, "Motor" to 1, "Construction" to 1)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="ConveyorTubeCurvedMedium",
	humanName="Curved Conveyor Tube",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=365.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 7, "Construction" to 20, "SmallTube" to 10, "Motor" to 6)
), BlockData(
	typeId="Conveyor",
	subtypeId="SmallShipConveyorHub",
	humanName="Conveyor Junction",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=313.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 15, "Construction" to 20, "SmallTube" to 15, "Motor" to 2)
), BlockData(
	typeId="Conveyor",
	subtypeId="ConveyorTubeSmallT",
	humanName="Small Conveyor Tube T Junction",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 2, "Motor" to 1, "Construction" to 2)
), BlockData(
	typeId="Conveyor",
	subtypeId="ConveyorTubeT",
	humanName="Conveyor Tube T Junction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=440.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 16, "Construction" to 24, "SmallTube" to 14, "Motor" to 6)
), BlockData(
	typeId="ConveyorSorter",
	xsiType="ConveyorSorter",
	subtypeId="LargeBlockConveyorSorter",
	humanName="Conveyor Sorter",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1362.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 50, "Construction" to 120, "SmallTube" to 50, "Computer" to 20, "Motor" to 2)
), BlockData(
	typeId="ConveyorSorter",
	xsiType="ConveyorSorter",
	subtypeId="MediumBlockConveyorSorter",
	humanName="Conveyor Sorter",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 1),
	mass=180.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 5, "Construction" to 12, "SmallTube" to 5, "Computer" to 5, "Motor" to 2)
), BlockData(
	typeId="ConveyorSorter",
	xsiType="ConveyorSorter",
	subtypeId="SmallBlockConveyorSorter",
	humanName="Small Conveyor Sorter",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=180.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 5, "Construction" to 12, "SmallTube" to 5, "Computer" to 5, "Motor" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockConveyorCap",
	humanName="Conveyor Cap",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=110.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 10, "Construction" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockConveyorCapMedium",
	humanName="Conveyor Cap Medium",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 1, 3),
	mass=110.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 10, "Construction" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockConveyorCap",
	humanName="Conveyor Cap",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=22.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 2, "Construction" to 2)
), BlockData(
	typeId="Passage",
	subtypeId="",
	humanName="Passage",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=574.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 74, "Construction" to 20, "SmallTube" to 48)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Passage2",
	humanName="Passage 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=574.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 74, "Construction" to 20, "SmallTube" to 48)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Passage2Wall",
	humanName="Passage 2 Side",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=390.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 50, "Construction" to 14, "SmallTube" to 32)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeStairs",
	humanName="Stairs",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=390.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 50, "Construction" to 30)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeRamp",
	humanName="Ramp",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=338.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 70, "Construction" to 16)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSteelCatwalk",
	humanName="Steel Catwalk",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=201.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 27, "Construction" to 5, "SmallTube" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSteelCatwalk2Sides",
	humanName="Steel Catwalk Two Sides",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=252.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 32, "Construction" to 7, "SmallTube" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSteelCatwalkCorner",
	humanName="Steel Catwalk Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=252.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 32, "Construction" to 7, "SmallTube" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSteelCatwalkPlate",
	humanName="Steel Catwalk Plate",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=193.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 23, "Construction" to 7, "SmallTube" to 17)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeCoverWall",
	humanName="Cover Walls",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=160.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "Construction" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeCoverWallHalf",
	humanName="Half Cover Wall",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=88.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "Construction" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeCoverWallHalfMirrored",
	humanName="Half Cover Wall Mirrored",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=88.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "Construction" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockInteriorWall",
	humanName="Interior Wall",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=155.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 25, "Construction" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeInteriorPillar",
	humanName="Interior Pillar",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=171.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 25, "Construction" to 10, "SmallTube" to 4)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="PassengerSeatLarge",
	humanName="Passenger Seat",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=220.0,
	pcu=15,
	components=mapOf("InteriorPlate" to 20, "Construction" to 20)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="PassengerSeatSmall",
	humanName="Passenger Seat",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=220.0,
	pcu=15,
	components=mapOf("InteriorPlate" to 20, "Construction" to 20)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="PassengerSeatSmallNew",
	humanName="Passenger Seat",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 2),
	mass=220.0,
	pcu=15,
	components=mapOf("InteriorPlate" to 20, "Construction" to 20)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="PassengerSeatSmallOffset",
	humanName="Passenger Seat Offset",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 2),
	mass=220.0,
	pcu=15,
	components=mapOf("InteriorPlate" to 20, "Construction" to 20)
), BlockData(
	typeId="Ladder2",
	subtypeId="",
	humanName="Ladder",
	gridSize=GridSize.LARGE,
	mass=230.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 10, "Construction" to 20, "SmallTube" to 10)
), BlockData(
	typeId="Ladder2",
	subtypeId="LadderShaft",
	humanName="Ladder Shaft",
	gridSize=GridSize.LARGE,
	mass=760.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 80, "Construction" to 40, "SmallTube" to 50)
), BlockData(
	typeId="Ladder2",
	subtypeId="LadderSmall",
	humanName="Ladder",
	gridSize=GridSize.SMALL,
	mass=230.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 10, "Construction" to 20, "SmallTube" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="AirDuct1",
	humanName="Willis Duct",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=600.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "LargeTube" to 4, "SteelPlate" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="AirDuct2",
	humanName="Willis Duct 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=600.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "LargeTube" to 4, "SteelPlate" to 10)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="AirDuctLight",
	humanName="Willis Duct Light",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=600.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "LargeTube" to 4, "SteelPlate" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="AirDuctCorner",
	humanName="Willis Duct Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=600.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "LargeTube" to 4, "SteelPlate" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="AirDuctT",
	humanName="Willis Duct T Junction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=545.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 15, "Construction" to 30, "LargeTube" to 4, "SteelPlate" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="AirDuctX",
	humanName="Willis Duct X Junction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=470.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 10, "Construction" to 30, "LargeTube" to 4, "SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="AirDuctRamp",
	humanName="Willis Duct Ramp",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=600.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "LargeTube" to 4, "SteelPlate" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="AirDuctGrate",
	humanName="Willis Duct Grate",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=110.0,
	pcu=1,
	components=mapOf("Construction" to 10, "InteriorPlate" to 10)
), BlockData(
	typeId="ReflectorLight",
	xsiType="ReflectorBlock",
	subtypeId="LargeBlockFrontLight",
	humanName="Spotlight",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=450.0,
	pcu=25,
	components=mapOf("SteelPlate" to 8, "LargeTube" to 2, "InteriorPlate" to 20, "Construction" to 15, "BulletproofGlass" to 4)
), BlockData(
	typeId="ReflectorLight",
	xsiType="ReflectorBlock",
	subtypeId="SmallBlockFrontLight",
	humanName="Spotlight",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=86.0,
	pcu=25,
	components=mapOf("SteelPlate" to 1, "LargeTube" to 1, "InteriorPlate" to 1, "Construction" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="SmallLight",
	humanName="Interior Light",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=16.0,
	pcu=25,
	components=mapOf("Construction" to 2)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="SmallBlockSmallLight",
	humanName="Interior Light",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=16.0,
	pcu=25,
	components=mapOf("Construction" to 2)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="LargeBlockLight_1corner",
	humanName="Corner Light",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=24.0,
	pcu=25,
	components=mapOf("Construction" to 3)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="LargeBlockLight_2corner",
	humanName="Corner Light - Double",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=48.0,
	pcu=25,
	components=mapOf("Construction" to 6)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="SmallBlockLight_1corner",
	humanName="Corner Light",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=16.0,
	pcu=25,
	components=mapOf("Construction" to 2)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="SmallBlockLight_2corner",
	humanName="Corner Light - Double",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=32.0,
	pcu=25,
	components=mapOf("Construction" to 4)
), BlockData(
	typeId="StoreBlock",
	xsiType="StoreBlock",
	subtypeId="StoreBlock",
	humanName="Store",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=938.0,
	pcu=10,
	components=mapOf("SteelPlate" to 30, "Construction" to 20, "Motor" to 6, "Display" to 4, "Computer" to 10)
), BlockData(
	typeId="SafeZoneBlock",
	xsiType="SafeZoneBlock",
	subtypeId="SafeZoneBlock",
	humanName="Safe Zone",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 2, 3),
	mass=25944.0,
	pcu=50,
	components=mapOf("SteelPlate" to 800, "Construction" to 180, "GravityGenerator" to 10, "ZoneChip" to 5, "MetalGrid" to 80, "Computer" to 120)
), BlockData(
	typeId="ContractBlock",
	xsiType="ContractBlock",
	subtypeId="ContractBlock",
	humanName="Contracts",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=938.0,
	pcu=10,
	components=mapOf("SteelPlate" to 30, "Construction" to 20, "Motor" to 6, "Display" to 4, "Computer" to 10)
), BlockData(
	typeId="VendingMachine",
	xsiType="VendingMachine",
	subtypeId="VendingMachine",
	humanName="Vending Machine",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=270.0,
	pcu=10,
	dlc="Economy",
	components=mapOf("InteriorPlate" to 20, "Construction" to 10, "Motor" to 4, "Display" to 4, "Computer" to 10)
), BlockData(
	typeId="StoreBlock",
	xsiType="StoreBlock",
	subtypeId="AtmBlock",
	humanName="ATM",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=642.0,
	pcu=10,
	dlc="Economy",
	components=mapOf("SteelPlate" to 20, "Construction" to 20, "Motor" to 2, "Computer" to 10, "Display" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="AngledInteriorWallA",
	humanName="Angled Interior Wall A",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=155.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 25, "Construction" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="AngledInteriorWallB",
	humanName="Angled Interior Wall B",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=155.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 25, "Construction" to 10)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="LargeBlockInsetLight",
	humanName="Inset Light",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=340.0,
	pcu=25,
	dlc="Automatons",
	components=mapOf("SteelPlate" to 10, "Construction" to 10, "InteriorPlate" to 20)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="SmallBlockInsetLight",
	humanName="Inset Light",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=39.0,
	pcu=25,
	dlc="Automatons",
	components=mapOf("SteelPlate" to 1, "Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="PipeWorkBlockA",
	humanName="Pipeworks A",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=470.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "LargeTube" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="PipeWorkBlockB",
	humanName="Pipeworks B",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=470.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "LargeTube" to 10)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="LargeBlockAccessPanel1",
	humanName="Access Panel 1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=136.0,
	pcu=5,
	dlc="Automatons",
	components=mapOf("Construction" to 15, "Computer" to 5, "InteriorPlate" to 5)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="LargeBlockAccessPanel2",
	humanName="Access Panel 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=175.0,
	pcu=5,
	dlc="Automatons",
	components=mapOf("Construction" to 15, "SmallTube" to 10, "InteriorPlate" to 5)
), BlockData(
	typeId="ButtonPanel",
	xsiType="ButtonPanel",
	subtypeId="LargeBlockAccessPanel3",
	humanName="Access Panel 3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=73.6,
	pcu=5,
	dlc="Automatons",
	components=mapOf("Construction" to 8, "Computer" to 3, "InteriorPlate" to 3)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="LargeBlockAccessPanel4",
	humanName="Access Panel 4",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=110.0,
	pcu=5,
	dlc="Automatons",
	components=mapOf("Construction" to 10, "InteriorPlate" to 10)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="SmallBlockAccessPanel1",
	humanName="Access Panel 1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 2, 2),
	mass=78.0,
	pcu=5,
	dlc="Automatons",
	components=mapOf("Construction" to 8, "SmallTube" to 2, "InteriorPlate" to 2)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="SmallBlockAccessPanel2",
	humanName="Access Panel 2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=23.0,
	pcu=5,
	dlc="Automatons",
	components=mapOf("Construction" to 2, "SmallTube" to 1, "InteriorPlate" to 1)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="SmallBlockAccessPanel3",
	humanName="Access Panel 3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=39.0,
	pcu=5,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "SmallTube" to 1, "InteriorPlate" to 1)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="SmallBlockAccessPanel4",
	humanName="Access Panel 4",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 2),
	mass=110.0,
	pcu=5,
	dlc="Automatons",
	components=mapOf("Construction" to 10, "InteriorPlate" to 10)
), BlockData(
	typeId="AirVent",
	xsiType="AirVent",
	subtypeId="AirVentFan",
	humanName="Air Vent Fan",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1001.0,
	pcu=10,
	dlc="Automatons",
	components=mapOf("SteelPlate" to 30, "Construction" to 20, "Motor" to 10, "Computer" to 5)
), BlockData(
	typeId="AirVent",
	xsiType="AirVent",
	subtypeId="AirVentFanFull",
	humanName="Air Vent Fan Full",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1381.0,
	pcu=10,
	dlc="Automatons",
	components=mapOf("SteelPlate" to 45, "Construction" to 30, "Motor" to 10, "Computer" to 5)
), BlockData(
	typeId="AirVent",
	xsiType="AirVent",
	subtypeId="SmallAirVentFan",
	humanName="Air Vent Fan",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=189.0,
	pcu=10,
	dlc="Automatons",
	components=mapOf("SteelPlate" to 3, "Construction" to 10, "Motor" to 2, "Computer" to 5)
), BlockData(
	typeId="AirVent",
	xsiType="AirVent",
	subtypeId="SmallAirVentFanFull",
	humanName="Air Vent Fan Full",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=269.0,
	pcu=10,
	dlc="Automatons",
	components=mapOf("SteelPlate" to 5, "Construction" to 15, "Motor" to 2, "Computer" to 5)
), BlockData(
	typeId="CameraBlock",
	xsiType="CameraBlock",
	subtypeId="LargeCameraTopMounted",
	humanName="Top Mounted Camera",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=40.6,
	pcu=25,
	dlc="Automatons",
	components=mapOf("SteelPlate" to 2, "Computer" to 3)
), BlockData(
	typeId="CameraBlock",
	xsiType="CameraBlock",
	subtypeId="SmallCameraTopMounted",
	humanName="Top Mounted Camera",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=40.6,
	pcu=25,
	dlc="Automatons",
	components=mapOf("SteelPlate" to 2, "Computer" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign1",
	humanName="Warning Sign Trade",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=50.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign2",
	humanName="Warning Sign Access",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=50.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign3",
	humanName="Warning Sign Safety",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=50.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign4",
	humanName="Warning Sign Storage",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=38.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign5",
	humanName="Warning Sign Explosive",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=50.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign6",
	humanName="Warning Sign Notice",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=50.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign7",
	humanName="Warning Sign Medical",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=38.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign8",
	humanName="Warning Sign Caution",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=44.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign9",
	humanName="Warning Sign Atmosphere",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=44.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign10",
	humanName="Warning Sign Construction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=44.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign11",
	humanName="Warning Sign Gravity",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=44.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign12",
	humanName="Warning Sign Airlock",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=44.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSign13",
	humanName="Warning Sign Hazard",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=44.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign1",
	humanName="Warning Sign Trade",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 1),
	mass=50.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign2",
	humanName="Warning Sign Access",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 1, 1),
	mass=38.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign3",
	humanName="Warning Sign Safety",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 1),
	mass=50.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign4",
	humanName="Warning Sign Storage",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 1, 1),
	mass=38.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign5",
	humanName="Warning Sign Explosive",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 2, 1),
	mass=50.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign6",
	humanName="Warning Sign Notice",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 1, 1),
	mass=38.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign7",
	humanName="Warning Sign Medical",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=38.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 4, "InteriorPlate" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign8",
	humanName="Warning Sign Caution",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign9",
	humanName="Warning Sign Atmosphere",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign10",
	humanName="Warning Sign Construction",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign11",
	humanName="Warning Sign Gravity",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign12",
	humanName="Warning Sign Airlock",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSign13",
	humanName="Warning Sign Hazard",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=1,
	dlc="Automatons",
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="SensorBlock",
	xsiType="SensorBlock",
	subtypeId="SmallBlockSensorReskin",
	humanName="Automaton Sensor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=158.2,
	pcu=25,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 5, "Construction" to 5, "Computer" to 6, "RadioCommunication" to 4, "Detector" to 6, "SteelPlate" to 2)
), BlockData(
	typeId="SensorBlock",
	xsiType="SensorBlock",
	subtypeId="LargeBlockSensorReskin",
	humanName="Automaton Sensor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=158.2,
	pcu=25,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 5, "Construction" to 5, "Computer" to 6, "RadioCommunication" to 4, "Detector" to 6, "SteelPlate" to 2)
), BlockData(
	typeId="MyProgrammableBlock",
	xsiType="ProgrammableBlock",
	subtypeId="LargeProgrammableBlockReskin",
	humanName="Automaton Programmable Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=534.4,
	pcu=100,
	dlc="Automatons",
	components=mapOf("SteelPlate" to 21, "Construction" to 4, "LargeTube" to 2, "Motor" to 1, "Display" to 1, "Computer" to 2)
), BlockData(
	typeId="MyProgrammableBlock",
	xsiType="ProgrammableBlock",
	subtypeId="SmallProgrammableBlockReskin",
	humanName="Automaton Programmable Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=138.4,
	pcu=100,
	dlc="Automatons",
	components=mapOf("SteelPlate" to 2, "Construction" to 2, "LargeTube" to 2, "Motor" to 1, "Display" to 1, "Computer" to 2)
), BlockData(
	typeId="TimerBlock",
	xsiType="TimerBlock",
	subtypeId="TimerBlockReskinLarge",
	humanName="Automaton Timer Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=259.0,
	pcu=25,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 6, "Construction" to 30, "Computer" to 5)
), BlockData(
	typeId="TimerBlock",
	xsiType="TimerBlock",
	subtypeId="TimerBlockReskinSmall",
	humanName="Automaton Timer Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=30.2,
	pcu=25,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 2, "Construction" to 3, "Computer" to 1)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="SpeederCockpit",
	humanName="Saddle Cockpit",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=374.0,
	pcu=50,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 30, "Construction" to 25, "Motor" to 2, "Computer" to 20, "Display" to 4)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="SpeederCockpitCompact",
	humanName="Saddle Cockpit Compact",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 3),
	mass=374.0,
	pcu=50,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 30, "Construction" to 25, "Motor" to 2, "Computer" to 20, "Display" to 4)
), BlockData(
	typeId="EmotionControllerBlock",
	xsiType="EmotionControllerBlock",
	subtypeId="EmotionControllerLarge",
	humanName="Emotion Controller",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=460.0,
	pcu=50,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 10, "Construction" to 30, "Computer" to 20, "Display" to 12, "BulletproofGlass" to 6)
), BlockData(
	typeId="EmotionControllerBlock",
	xsiType="EmotionControllerBlock",
	subtypeId="EmotionControllerSmall",
	humanName="Emotion Controller",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=51.0,
	pcu=50,
	dlc="Automatons",
	components=mapOf("InteriorPlate" to 1, "Construction" to 3, "Computer" to 5, "Display" to 1, "BulletproofGlass" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorPanelLight",
	humanName="Light Armor Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorCenterPanelLight",
	humanName="Light Armor Centered Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorSlopedSidePanelLight",
	humanName="Light Armor Panel Side",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorSlopedPanelLight",
	humanName="Light Armor Panel Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=120.0,
	pcu=1,
	components=mapOf("SteelPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorHalfPanelLight",
	humanName="Light Armor Half Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorHalfCenterPanelLight",
	humanName="Light Armor Centered Half Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorQuarterPanelLight",
	humanName="Light Armor Quarter Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=40.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedPanelLight",
	humanName="Light Armor Panel 2x1 Slope Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedPanelTipLight",
	humanName="Light Armor Panel 2x1 Slope Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedSideBasePanelLight",
	humanName="Light Armor Panel 2x1 Base Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedSideTipPanelLight",
	humanName="Light Armor Panel 2x1 Tip Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedSideBasePanelLightInv",
	humanName="Light Armor Panel 2x1 Base Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedSideTipPanelLightInv",
	humanName="Light Armor Panel 2x1 Tip Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorHalfSlopedPanelLight",
	humanName="Light Armor Panel Half Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1HalfSlopedPanelLightRight",
	humanName="Light Armor Half Panel 2x1 Base Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1HalfSlopedTipPanelLightRight",
	humanName="Light Armor Half Panel 2x1 Tip Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1HalfSlopedPanelLightLeft",
	humanName="Light Armor Half Panel 2x1 Base Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1HalfSlopedTipPanelLightLeft",
	humanName="Light Armor Half Panel 2x1 Tip Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeRoundArmorPanelLight",
	humanName="Light Armor Panel Round",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=160.0,
	pcu=1,
	components=mapOf("SteelPlate" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeRoundArmorPanelCornerLight",
	humanName="Light Armor Panel Round Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorPanelHeavy",
	humanName="Heavy Armor Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=330.0,
	pcu=1,
	components=mapOf("SteelPlate" to 15, "MetalGrid" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorCenterPanelHeavy",
	humanName="Heavy Armor Centered Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=330.0,
	pcu=1,
	components=mapOf("SteelPlate" to 15, "MetalGrid" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorSlopedSidePanelHeavy",
	humanName="Heavy Armor Panel Side",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=178.0,
	pcu=1,
	components=mapOf("SteelPlate" to 8, "MetalGrid" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorSlopedPanelHeavy",
	humanName="Heavy Armor Panel Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=462.0,
	pcu=1,
	components=mapOf("SteelPlate" to 21, "MetalGrid" to 7)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorHalfPanelHeavy",
	humanName="Heavy Armor Half Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=178.0,
	pcu=1,
	components=mapOf("SteelPlate" to 8, "MetalGrid" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorHalfCenterPanelHeavy",
	humanName="Heavy Armor Centered Half Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=178.0,
	pcu=1,
	components=mapOf("SteelPlate" to 8, "MetalGrid" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorQuarterPanelHeavy",
	humanName="Heavy Armor Quarter Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=112.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5, "MetalGrid" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedPanelHeavy",
	humanName="Heavy Armor Panel 2x1 Slope Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=396.0,
	pcu=1,
	components=mapOf("SteelPlate" to 18, "MetalGrid" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedPanelTipHeavy",
	humanName="Heavy Armor Panel 2x1 Slope Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=396.0,
	pcu=1,
	components=mapOf("SteelPlate" to 18, "MetalGrid" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedSideBasePanelHeavy",
	humanName="Heavy Armor Panel 2x1 Base Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=264.0,
	pcu=1,
	components=mapOf("SteelPlate" to 12, "MetalGrid" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedSideTipPanelHeavy",
	humanName="Heavy Armor Panel 2x1 Tip Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=132.0,
	pcu=1,
	components=mapOf("SteelPlate" to 6, "MetalGrid" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedSideBasePanelHeavyInv",
	humanName="Heavy Armor Panel 2x1 Base Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=264.0,
	pcu=1,
	components=mapOf("SteelPlate" to 12, "MetalGrid" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1SlopedSideTipPanelHeavyInv",
	humanName="Heavy Armor Panel 2x1 Tip Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=132.0,
	pcu=1,
	components=mapOf("SteelPlate" to 6, "MetalGrid" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmorHalfSlopedPanelHeavy",
	humanName="Heavy Armor Panel Half Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=198.0,
	pcu=1,
	components=mapOf("SteelPlate" to 9, "MetalGrid" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1HalfSlopedPanelHeavyRight",
	humanName="Heavy Armor Half Panel 2x1 Base Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=198.0,
	pcu=1,
	components=mapOf("SteelPlate" to 9, "MetalGrid" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1HalfSlopedTipPanelHeavyRight",
	humanName="Heavy Armor Half Panel 2x1 Tip Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=198.0,
	pcu=1,
	components=mapOf("SteelPlate" to 9, "MetalGrid" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1HalfSlopedPanelHeavyLeft",
	humanName="Heavy Armor Half Panel 2x1 Base Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=198.0,
	pcu=1,
	components=mapOf("SteelPlate" to 9, "MetalGrid" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeArmor2x1HalfSlopedTipPanelHeavyLeft",
	humanName="Heavy Armor Half Panel 2x1 Tip Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=198.0,
	pcu=1,
	components=mapOf("SteelPlate" to 9, "MetalGrid" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeRoundArmorPanelHeavy",
	humanName="Heavy Armor Panel Round",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=528.0,
	pcu=1,
	components=mapOf("SteelPlate" to 24, "MetalGrid" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeRoundArmorPanelCornerHeavy",
	humanName="Heavy Armor Panel Round Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=330.0,
	pcu=1,
	components=mapOf("SteelPlate" to 15, "MetalGrid" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorPanelLight",
	humanName="Light Armor Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorCenterPanelLight",
	humanName="Light Armor Centered Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorSlopedSidePanelLight",
	humanName="Light Armor Panel Side",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorSlopedPanelLight",
	humanName="Light Armor Panel Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorHalfPanelLight",
	humanName="Light Armor Half Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorHalfCenterPanelLight",
	humanName="Light Armor Centered Half Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorQuarterPanelLight",
	humanName="Light Armor Quarter Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedPanelLight",
	humanName="Light Armor Panel 2x1 Slope Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedPanelTipLight",
	humanName="Light Armor Panel 2x1 Slope Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedSideBasePanelLight",
	humanName="Light Armor Panel 2x1 Base Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedSideTipPanelLight",
	humanName="Light Armor Panel 2x1 Tip Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedSideBasePanelLightInv",
	humanName="Light Armor Panel 2x1 Base Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedSideTipPanelLightInv",
	humanName="Light Armor Panel 2x1 Tip Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorHalfSlopedPanelLight",
	humanName="Light Armor Panel Half Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1HalfSlopedPanelLightRight",
	humanName="Light Armor Half Panel 2x1 Base Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1HalfSlopedTipPanelLightRight",
	humanName="Light Armor Half Panel 2x1 Tip Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1HalfSlopedPanelLightLeft",
	humanName="Light Armor Half Panel 2x1 Base Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1HalfSlopedTipPanelLightLeft",
	humanName="Light Armor Half Panel 2x1 Tip Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallRoundArmorPanelLight",
	humanName="Light Armor Panel Round",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallRoundArmorPanelCornerLight",
	humanName="Light Armor Panel Round Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorPanelHeavy",
	humanName="Heavy Armor Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorCenterPanelHeavy",
	humanName="Heavy Armor Centered Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorSlopedSidePanelHeavy",
	humanName="Heavy Armor Panel Side",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorSlopedPanelHeavy",
	humanName="Heavy Armor Panel Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorHalfPanelHeavy",
	humanName="Heavy Armor Half Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorHalfCenterPanelHeavy",
	humanName="Heavy Armor Centered Half Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorQuarterPanelHeavy",
	humanName="Heavy Armor Quarter Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedPanelHeavy",
	humanName="Heavy Armor Panel 2x1 Slope Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedPanelTipHeavy",
	humanName="Heavy Armor Panel 2x1 Slope Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedSideBasePanelHeavy",
	humanName="Heavy Armor Panel 2x1 Base Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedSideTipPanelHeavy",
	humanName="Heavy Armor Panel 2x1 Tip Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedSideBasePanelHeavyInv",
	humanName="Heavy Armor Panel 2x1 Base Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1SlopedSideTipPanelHeavyInv",
	humanName="Heavy Armor Panel 2x1 Tip Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorHalfSlopedPanelHeavy",
	humanName="Heavy Armor Panel Half Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1HalfSlopedPanelHeavyRight",
	humanName="Heavy Armor Half Panel 2x1 Base Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1HalfSlopedTipPanelHeavyRight",
	humanName="Heavy Armor Half Panel 2x1 Tip Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1HalfSlopedPanelHeavyLeft",
	humanName="Heavy Armor Half Panel 2x1 Base Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmor2x1HalfSlopedTipPanelHeavyLeft",
	humanName="Heavy Armor Half Panel 2x1 Tip Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallRoundArmorPanelHeavy",
	humanName="Heavy Armor Panel Round",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallRoundArmorPanelCornerHeavy",
	humanName="Heavy Armor Panel Round Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="Suspension3x3",
	humanName="Wheel Suspension 3x3 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="Suspension5x5",
	humanName="Wheel Suspension 5x5 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 3, 2),
	mass=2820.0,
	pcu=50,
	components=mapOf("SteelPlate" to 70, "Construction" to 40, "LargeTube" to 20, "SmallTube" to 30, "Motor" to 20)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="Suspension1x1",
	humanName="Wheel Suspension 1x1 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="Suspension2x2",
	humanName="Wheel Suspension 2x2 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallSuspension3x3",
	humanName="Wheel Suspension 3x3 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallSuspension5x5",
	humanName="Wheel Suspension 5x5 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 2),
	mass=480.0,
	pcu=50,
	components=mapOf("SteelPlate" to 16, "Construction" to 12, "SmallTube" to 4, "Motor" to 2)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallSuspension1x1",
	humanName="Wheel Suspension 1x1 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallSuspension2x2",
	humanName="Wheel Suspension 2x2 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="Suspension3x3mirrored",
	humanName="Wheel Suspension 3x3 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="Suspension5x5mirrored",
	humanName="Wheel Suspension 5x5 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 3, 2),
	mass=2820.0,
	pcu=50,
	components=mapOf("SteelPlate" to 70, "Construction" to 40, "LargeTube" to 20, "SmallTube" to 30, "Motor" to 20)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="Suspension1x1mirrored",
	humanName="Wheel Suspension 1x1 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="Suspension2x2Mirrored",
	humanName="Wheel Suspension 2x2 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallSuspension3x3mirrored",
	humanName="Wheel Suspension 3x3 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallSuspension5x5mirrored",
	humanName="Wheel Suspension 5x5 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 2),
	mass=480.0,
	pcu=50,
	components=mapOf("SteelPlate" to 16, "Construction" to 12, "SmallTube" to 4, "Motor" to 2)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallSuspension1x1mirrored",
	humanName="Wheel Suspension 1x1 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallSuspension2x2Mirrored",
	humanName="Wheel Suspension 2x2 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallRealWheel1x1",
	humanName="Wheel 1x1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=105.0,
	pcu=25,
	components=mapOf("SteelPlate" to 2, "Construction" to 5, "LargeTube" to 1)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallRealWheel2x2",
	humanName="Wheel 2x2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 1, 2),
	mass=355.0,
	pcu=25,
	components=mapOf("SteelPlate" to 8, "Construction" to 15, "LargeTube" to 3)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallRealWheel",
	humanName="Wheel 3x3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 1, 3),
	mass=355.0,
	pcu=25,
	components=mapOf("SteelPlate" to 8, "Construction" to 15, "LargeTube" to 3)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallRealWheel5x5",
	humanName="Wheel 5x5",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 3, 5),
	mass=625.0,
	pcu=25,
	components=mapOf("SteelPlate" to 15, "Construction" to 25, "LargeTube" to 5)
), BlockData(
	typeId="Wheel",
	subtypeId="RealWheel1x1",
	humanName="Wheel 1x1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1090.0,
	pcu=25,
	components=mapOf("SteelPlate" to 30, "Construction" to 30, "LargeTube" to 10)
), BlockData(
	typeId="Wheel",
	subtypeId="RealWheel2x2",
	humanName="Wheel 2x2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 2),
	mass=1695.0,
	pcu=25,
	components=mapOf("SteelPlate" to 50, "Construction" to 40, "LargeTube" to 15)
), BlockData(
	typeId="Wheel",
	subtypeId="RealWheel",
	humanName="Wheel 3x3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 2, 3),
	mass=2300.0,
	pcu=25,
	components=mapOf("SteelPlate" to 70, "Construction" to 50, "LargeTube" to 20)
), BlockData(
	typeId="Wheel",
	subtypeId="RealWheel5x5",
	humanName="Wheel 5x5",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 3, 5),
	mass=3910.0,
	pcu=25,
	components=mapOf("SteelPlate" to 130, "Construction" to 70, "LargeTube" to 30)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallRealWheel1x1mirrored",
	humanName="Wheel 1x1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=105.0,
	pcu=25,
	components=mapOf("SteelPlate" to 2, "Construction" to 5, "LargeTube" to 1)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallRealWheel2x2Mirrored",
	humanName="Wheel 2x2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 1, 2),
	mass=355.0,
	pcu=25,
	components=mapOf("SteelPlate" to 8, "Construction" to 15, "LargeTube" to 3)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallRealWheelmirrored",
	humanName="Wheel 3x3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 1, 3),
	mass=355.0,
	pcu=25,
	components=mapOf("SteelPlate" to 8, "Construction" to 15, "LargeTube" to 3)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallRealWheel5x5mirrored",
	humanName="Wheel 5x5",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 3, 5),
	mass=625.0,
	pcu=25,
	components=mapOf("SteelPlate" to 15, "Construction" to 25, "LargeTube" to 5)
), BlockData(
	typeId="Wheel",
	subtypeId="RealWheel1x1mirrored",
	humanName="Wheel 1x1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1090.0,
	pcu=25,
	components=mapOf("SteelPlate" to 30, "Construction" to 30, "LargeTube" to 10)
), BlockData(
	typeId="Wheel",
	subtypeId="RealWheel2x2Mirrored",
	humanName="Wheel 2x2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 2),
	mass=1695.0,
	pcu=25,
	components=mapOf("SteelPlate" to 50, "Construction" to 40, "LargeTube" to 15)
), BlockData(
	typeId="Wheel",
	subtypeId="RealWheelmirrored",
	humanName="Wheel 3x3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 2, 3),
	mass=2300.0,
	pcu=25,
	components=mapOf("SteelPlate" to 70, "Construction" to 50, "LargeTube" to 20)
), BlockData(
	typeId="Wheel",
	subtypeId="RealWheel5x5mirrored",
	humanName="Wheel 5x5",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 3, 5),
	mass=3910.0,
	pcu=25,
	components=mapOf("SteelPlate" to 130, "Construction" to 70, "LargeTube" to 30)
), BlockData(
	typeId="Wheel",
	subtypeId="Wheel1x1",
	humanName="Wheel 1x1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1090.0,
	pcu=25,
	components=mapOf("SteelPlate" to 30, "Construction" to 30, "LargeTube" to 10)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallWheel1x1",
	humanName="Wheel 1x1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=105.0,
	pcu=25,
	components=mapOf("SteelPlate" to 2, "Construction" to 5, "LargeTube" to 1)
), BlockData(
	typeId="Wheel",
	subtypeId="Wheel3x3",
	humanName="Wheel 3x3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 1, 3),
	mass=2300.0,
	pcu=25,
	components=mapOf("SteelPlate" to 70, "Construction" to 50, "LargeTube" to 20)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallWheel3x3",
	humanName="Wheel 3x3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 1, 3),
	mass=355.0,
	pcu=25,
	components=mapOf("SteelPlate" to 8, "Construction" to 15, "LargeTube" to 3)
), BlockData(
	typeId="Wheel",
	subtypeId="Wheel5x5",
	humanName="Wheel 5x5",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 2, 5),
	mass=3910.0,
	pcu=25,
	components=mapOf("SteelPlate" to 130, "Construction" to 70, "LargeTube" to 30)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallWheel5x5",
	humanName="Wheel 5x5",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 2, 5),
	mass=625.0,
	pcu=25,
	components=mapOf("SteelPlate" to 15, "Construction" to 25, "LargeTube" to 5)
), BlockData(
	typeId="Wheel",
	subtypeId="Wheel2x2",
	humanName="Wheel 2x2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 2),
	mass=1695.0,
	pcu=25,
	components=mapOf("SteelPlate" to 50, "Construction" to 40, "LargeTube" to 15)
), BlockData(
	typeId="Wheel",
	subtypeId="SmallWheel2x2",
	humanName="Wheel 2x2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 1, 2),
	mass=230.0,
	pcu=25,
	components=mapOf("SteelPlate" to 5, "Construction" to 10, "LargeTube" to 2)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="ShortSuspension3x3",
	humanName="Short Wheel Suspension 3x3 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="ShortSuspension5x5",
	humanName="Short Wheel Suspension 5x5 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 2, 2),
	mass=2240.0,
	pcu=50,
	components=mapOf("SteelPlate" to 45, "Construction" to 30, "LargeTube" to 20, "SmallTube" to 30, "Motor" to 20)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="ShortSuspension1x1",
	humanName="Short Wheel Suspension 1x1 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="ShortSuspension2x2",
	humanName="Short Wheel Suspension 2x2 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallShortSuspension3x3",
	humanName="Short Wheel Suspension 3x3 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallShortSuspension5x5",
	humanName="Short Wheel Suspension 5x5 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 2, 2),
	mass=344.0,
	pcu=50,
	components=mapOf("SteelPlate" to 10, "Construction" to 10, "SmallTube" to 4, "Motor" to 2)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallShortSuspension1x1",
	humanName="Short Wheel Suspension 1x1 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallShortSuspension2x2",
	humanName="Short Wheel Suspension 2x2 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="ShortSuspension3x3mirrored",
	humanName="Short Wheel Suspension 3x3 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="ShortSuspension5x5mirrored",
	humanName="Short Wheel Suspension 5x5 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 2, 2),
	mass=2240.0,
	pcu=50,
	components=mapOf("SteelPlate" to 45, "Construction" to 30, "LargeTube" to 20, "SmallTube" to 30, "Motor" to 20)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="ShortSuspension1x1mirrored",
	humanName="Short Wheel Suspension 1x1 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="ShortSuspension2x2Mirrored",
	humanName="Short Wheel Suspension 2x2 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallShortSuspension3x3mirrored",
	humanName="Short Wheel Suspension 3x3 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallShortSuspension5x5mirrored",
	humanName="Short Wheel Suspension 5x5 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 2, 2),
	mass=344.0,
	pcu=50,
	components=mapOf("SteelPlate" to 10, "Construction" to 10, "SmallTube" to 4, "Motor" to 2)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallShortSuspension1x1mirrored",
	humanName="Short Wheel Suspension 1x1 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="SmallShortSuspension2x2Mirrored",
	humanName="Short Wheel Suspension 2x2 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockSmallThrust",
	humanName="Ion Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=121.0,
	pcu=15,
	components=mapOf("SteelPlate" to 2, "Construction" to 2, "LargeTube" to 1, "Thrust" to 1)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockLargeThrust",
	humanName="Large Ion Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 2, 4),
	mass=721.0,
	pcu=15,
	components=mapOf("SteelPlate" to 5, "Construction" to 2, "LargeTube" to 5, "Thrust" to 12)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockSmallThrust",
	humanName="Ion Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=4380.0,
	pcu=15,
	components=mapOf("SteelPlate" to 25, "Construction" to 60, "LargeTube" to 8, "Thrust" to 80)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockLargeThrust",
	humanName="Large Ion Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 2, 4),
	mass=43200.0,
	pcu=15,
	components=mapOf("SteelPlate" to 150, "Construction" to 100, "LargeTube" to 40, "Thrust" to 960)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockLargeHydrogenThrust",
	humanName="Large Hydrogen Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=6940.0,
	pcu=15,
	components=mapOf("SteelPlate" to 150, "Construction" to 180, "MetalGrid" to 250, "LargeTube" to 40)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockSmallHydrogenThrust",
	humanName="Hydrogen Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1420.0,
	pcu=15,
	components=mapOf("SteelPlate" to 25, "Construction" to 60, "MetalGrid" to 40, "LargeTube" to 8)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockLargeHydrogenThrust",
	humanName="Large Hydrogen Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=1222.0,
	pcu=15,
	components=mapOf("SteelPlate" to 30, "Construction" to 30, "MetalGrid" to 22, "LargeTube" to 10)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockSmallHydrogenThrust",
	humanName="Hydrogen Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=334.0,
	pcu=15,
	components=mapOf("SteelPlate" to 7, "Construction" to 15, "MetalGrid" to 4, "LargeTube" to 2)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockLargeAtmosphericThrust",
	humanName="Large Atmospheric Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 5),
	mass=32970.0,
	pcu=15,
	components=mapOf("SteelPlate" to 230, "Construction" to 60, "LargeTube" to 50, "MetalGrid" to 40, "Motor" to 1100)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockSmallAtmosphericThrust",
	humanName="Atmospheric Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 3),
	mass=4000.0,
	pcu=15,
	components=mapOf("SteelPlate" to 35, "Construction" to 50, "LargeTube" to 8, "MetalGrid" to 10, "Motor" to 110)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockLargeAtmosphericThrust",
	humanName="Large Atmospheric Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 5),
	mass=2948.0,
	pcu=15,
	components=mapOf("SteelPlate" to 20, "Construction" to 30, "LargeTube" to 4, "MetalGrid" to 8, "Motor" to 90)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockSmallAtmosphericThrust",
	humanName="Atmospheric Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 3),
	mass=699.0,
	pcu=15,
	components=mapOf("SteelPlate" to 3, "Construction" to 22, "LargeTube" to 1, "MetalGrid" to 1, "Motor" to 18)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockLargeFlatAtmosphericThrust",
	humanName="Large Flat Atmospheric Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 2),
	mass=12190.0,
	pcu=15,
	components=mapOf("SteelPlate" to 90, "Construction" to 25, "LargeTube" to 20, "MetalGrid" to 15, "Motor" to 400)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockLargeFlatAtmosphericThrustDShape",
	humanName="Large Flat Atmospheric Thruster D Shape",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 2),
	mass=12190.0,
	pcu=15,
	components=mapOf("SteelPlate" to 90, "Construction" to 25, "LargeTube" to 20, "MetalGrid" to 15, "Motor" to 400)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockSmallFlatAtmosphericThrust",
	humanName="Flat Atmospheric Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1273.0,
	pcu=15,
	components=mapOf("SteelPlate" to 15, "Construction" to 20, "LargeTube" to 3, "MetalGrid" to 3, "Motor" to 30)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockSmallFlatAtmosphericThrustDShape",
	humanName="Flat Atmospheric Thruster D Shape",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1273.0,
	pcu=15,
	components=mapOf("SteelPlate" to 15, "Construction" to 20, "LargeTube" to 3, "MetalGrid" to 3, "Motor" to 30)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockLargeFlatAtmosphericThrust",
	humanName="Large Flat Atmospheric Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 2),
	mass=1060.0,
	pcu=15,
	components=mapOf("SteelPlate" to 8, "Construction" to 14, "LargeTube" to 2, "MetalGrid" to 3, "Motor" to 30)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockLargeFlatAtmosphericThrustDShape",
	humanName="Large Flat Atmospheric Thruster D Shape",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 2),
	mass=1060.0,
	pcu=15,
	components=mapOf("SteelPlate" to 8, "Construction" to 14, "LargeTube" to 2, "MetalGrid" to 3, "Motor" to 30)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockSmallFlatAtmosphericThrust",
	humanName="Flat Atmospheric Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=303.0,
	pcu=15,
	components=mapOf("SteelPlate" to 2, "Construction" to 11, "LargeTube" to 1, "MetalGrid" to 1, "Motor" to 6)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockSmallFlatAtmosphericThrustDShape",
	humanName="Flat Atmospheric Thruster D Shape",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=303.0,
	pcu=15,
	components=mapOf("SteelPlate" to 2, "Construction" to 11, "LargeTube" to 1, "MetalGrid" to 1, "Motor" to 6)
), BlockData(
	typeId="SolarPanel",
	xsiType="SolarPanel",
	subtypeId="LargeBlockColorableSolarPanel",
	humanName="Colorable Solar Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 4, 1),
	mass=516.8,
	pcu=55,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 4, "Construction" to 14, "Girder" to 12, "Computer" to 4, "SolarCell" to 32, "BulletproofGlass" to 4)
), BlockData(
	typeId="SolarPanel",
	xsiType="SolarPanel",
	subtypeId="LargeBlockColorableSolarPanelCorner",
	humanName="Colorable Solar Panel Slope Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 4, 1),
	mass=258.8,
	pcu=55,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 2, "Construction" to 7, "Girder" to 6, "Computer" to 4, "SolarCell" to 16, "BulletproofGlass" to 2)
), BlockData(
	typeId="SolarPanel",
	xsiType="SolarPanel",
	subtypeId="LargeBlockColorableSolarPanelCornerInverted",
	humanName="Colorable Solar Panel Slope Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 4, 1),
	mass=258.8,
	pcu=55,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 2, "Construction" to 7, "Girder" to 6, "Computer" to 4, "SolarCell" to 16, "BulletproofGlass" to 2)
), BlockData(
	typeId="SolarPanel",
	xsiType="SolarPanel",
	subtypeId="SmallBlockColorableSolarPanel",
	humanName="Colorable Solar Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 10, 1),
	mass=143.2,
	pcu=55,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 2, "Construction" to 2, "Girder" to 4, "Computer" to 1, "SolarCell" to 8, "BulletproofGlass" to 1)
), BlockData(
	typeId="SolarPanel",
	xsiType="SolarPanel",
	subtypeId="SmallBlockColorableSolarPanelCorner",
	humanName="Colorable Solar Panel Slope Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 10, 1),
	mass=87.2,
	pcu=55,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 1, "Construction" to 2, "Girder" to 2, "Computer" to 1, "SolarCell" to 4, "BulletproofGlass" to 1)
), BlockData(
	typeId="SolarPanel",
	xsiType="SolarPanel",
	subtypeId="SmallBlockColorableSolarPanelCornerInverted",
	humanName="Colorable Solar Panel Slope Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 10, 1),
	mass=87.2,
	pcu=55,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 1, "Construction" to 2, "Girder" to 2, "Computer" to 1, "SolarCell" to 4, "BulletproofGlass" to 1)
), BlockData(
	typeId="WindTurbine",
	xsiType="WindTurbine",
	subtypeId="LargeBlockWindTurbineReskin",
	humanName="Twin-blade Wind Turbine",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 5, 5),
	mass=616.4,
	pcu=55,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 40, "Motor" to 8, "Construction" to 20, "Girder" to 24, "Computer" to 2)
), BlockData(
	typeId="Beacon",
	xsiType="Beacon",
	subtypeId="LargeBlockBeaconReskin",
	humanName="Round Beacon",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=2662.0,
	pcu=50,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 80, "Construction" to 30, "LargeTube" to 20, "Computer" to 10, "RadioCommunication" to 40)
), BlockData(
	typeId="Beacon",
	xsiType="Beacon",
	subtypeId="SmallBlockBeaconReskin",
	humanName="Round Beacon",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=84.2,
	pcu=50,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 2, "Construction" to 1, "SmallTube" to 1, "Computer" to 1, "RadioCommunication" to 4)
), BlockData(
	typeId="CryoChamber",
	xsiType="CryoChamber",
	subtypeId="LargeBlockCryoRoom",
	humanName="Inset Cryo Room",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1142.0,
	pcu=15,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 40, "Construction" to 20, "Motor" to 8, "Display" to 8, "Medical" to 3, "Computer" to 30, "BulletproofGlass" to 10)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="SmallBlockCapCockpit",
	humanName="Cab Cockpit",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=689.0,
	pcu=150,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 20, "Construction" to 10, "Motor" to 1, "Display" to 4, "Computer" to 15, "BulletproofGlass" to 10)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="HoloLCDLarge",
	humanName="Holo LCD",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=105.6,
	pcu=50,
	dlc="DecorativeBlocks3",
	components=mapOf("Construction" to 10, "Motor" to 1, "Computer" to 8)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="HoloLCDSmall",
	humanName="Holo LCD",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=65.6,
	pcu=50,
	dlc="DecorativeBlocks3",
	components=mapOf("Construction" to 5, "Motor" to 1, "Computer" to 8)
), BlockData(
	typeId="MedicalRoom",
	xsiType="MedicalRoom",
	subtypeId="LargeMedicalRoomReskin",
	humanName="Corner Medical Room",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 2),
	mass=4257.0,
	pcu=30,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 240, "Construction" to 80, "MetalGrid" to 60, "SmallTube" to 20, "LargeTube" to 5, "Display" to 10, "Computer" to 10, "Medical" to 15)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="LargeBlockInsetAquarium",
	humanName="Inset Aquarium",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1344.0,
	pcu=25,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 30, "Construction" to 30, "Motor" to 1, "SmallTube" to 10, "GravityGenerator" to 1, "BulletproofGlass" to 10)
), BlockData(
	typeId="CryoChamber",
	xsiType="CryoChamber",
	subtypeId="LargeBlockHalfBed",
	humanName="Half Bed",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=218.0,
	pcu=15,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 14, "Construction" to 16, "SmallTube" to 6, "Display" to 3)
), BlockData(
	typeId="CryoChamber",
	xsiType="CryoChamber",
	subtypeId="LargeBlockHalfBedOffset",
	humanName="Half Bed Open",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=218.0,
	pcu=15,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 14, "Construction" to 16, "SmallTube" to 6, "Display" to 3)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeFullBlockLCDPanel",
	humanName="Inset LCD Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=391.2,
	pcu=50,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "Computer" to 6, "Display" to 10, "BulletproofGlass" to 6)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="SmallFullBlockLCDPanel",
	humanName="Inset LCD Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=83.8,
	pcu=50,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 4, "Construction" to 4, "Computer" to 4, "Display" to 3, "BulletproofGlass" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeDiagonalLCDPanel",
	humanName="Sloped LCD Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=311.2,
	pcu=50,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 10, "Construction" to 10, "Computer" to 6, "Display" to 10, "BulletproofGlass" to 8)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="SmallDiagonalLCDPanel",
	humanName="Sloped LCD Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=83.8,
	pcu=50,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 4, "Construction" to 4, "Computer" to 4, "Display" to 3, "BulletproofGlass" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeCurvedLCDPanel",
	humanName="Curved LCD Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=451.2,
	pcu=50,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "Computer" to 6, "Display" to 10, "BulletproofGlass" to 10)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="SmallCurvedLCDPanel",
	humanName="Curved LCD Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=83.8,
	pcu=50,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 4, "Construction" to 4, "Computer" to 4, "Display" to 3, "BulletproofGlass" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Truss",
	humanName="Scaffold Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=160.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 20, "SmallTube" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussSmall",
	humanName="Scaffold Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=16.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 2, "SmallTube" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussSloped",
	humanName="Scaffold Block Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 10, "SmallTube" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussSlopedSmall",
	humanName="Scaffold Block Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=10.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 1, "SmallTube" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussAngled",
	humanName="Scaffold Block Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=160.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 20, "SmallTube" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussAngledSmall",
	humanName="Scaffold Block Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=16.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 2, "SmallTube" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussHalf",
	humanName="Half Scaffold Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 10, "SmallTube" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussHalfSmall",
	humanName="Half Scaffold Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=10.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 1, "SmallTube" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussFloor",
	humanName="Walkable Scaffold Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=392.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 24, "Construction" to 16, "SmallTube" to 30)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussFloorAngled",
	humanName="Walkable Scaffold Block Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=392.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 24, "Construction" to 16, "SmallTube" to 30)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussFloorAngledInverted",
	humanName="Walkable Scaffold Block Corner Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=392.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 24, "Construction" to 16, "SmallTube" to 30)
), BlockData(
	typeId="CubeBlock",
	subtypeId="TrussFloorHalf",
	humanName="Walkable Half Scaffold Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=264.0,
	pcu=1,
	dlc="DecorativeBlocks3",
	components=mapOf("Girder" to 12, "Construction" to 14, "SmallTube" to 20)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="LargeCrate",
	humanName="Cargo Crate",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=720.0,
	pcu=10,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 20, "SmallTube" to 8, "Motor" to 4, "Construction" to 24)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBarrel",
	humanName="Barrel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=173.0,
	pcu=10,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 5, "LargeTube" to 1, "Construction" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBarrel",
	humanName="Barrel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 2),
	mass=173.0,
	pcu=10,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 5, "LargeTube" to 1, "Construction" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBarrelThree",
	humanName="Three Barrels",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=519.0,
	pcu=10,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 15, "LargeTube" to 3, "Construction" to 18)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBarrelStack",
	humanName="Stacked Barrels",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1802.0,
	pcu=10,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 50, "LargeTube" to 10, "MetalGrid" to 4, "Girder" to 8, "Construction" to 60)
), BlockData(
	typeId="Warhead",
	xsiType="Warhead",
	subtypeId="LargeExplosiveBarrel",
	humanName="Explosive Barrel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=185.2,
	pcu=100,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 5, "LargeTube" to 1, "Construction" to 6, "SmallTube" to 2, "Computer" to 1, "Explosives" to 2)
), BlockData(
	typeId="Warhead",
	xsiType="Warhead",
	subtypeId="SmallExplosiveBarrel",
	humanName="Explosive Barrel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 2),
	mass=185.2,
	pcu=100,
	dlc="DecorativeBlocks3",
	components=mapOf("SteelPlate" to 5, "LargeTube" to 1, "Construction" to 6, "SmallTube" to 2, "Computer" to 1, "Explosives" to 2)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockInsetPlantCouch",
	humanName="Inset Couch",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=670.0,
	pcu=15,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 30, "Construction" to 30, "SmallTube" to 10, "BulletproofGlass" to 20)
), BlockData(
	typeId="CryoChamber",
	xsiType="CryoChamber",
	subtypeId="LargeBlockInsetBed",
	humanName="Inset Bed",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=452.0,
	pcu=15,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 60, "Construction" to 30, "SmallTube" to 8)
), BlockData(
	typeId="ButtonPanel",
	xsiType="ButtonPanel",
	subtypeId="LargeBlockInsetButtonPanel",
	humanName="Inset Button Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=304.0,
	pcu=75,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "Computer" to 20, "Display" to 10)
), BlockData(
	typeId="Jukebox",
	xsiType="Jukebox",
	subtypeId="LargeBlockInsetEntertainmentCorner",
	humanName="Inset Entertainment Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=316.0,
	pcu=25,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 30, "Construction" to 20, "Computer" to 10, "Display" to 8)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="LargeBlockInsetBookshelf",
	humanName="Inset Bookshelf",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=330.0,
	pcu=10,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 30, "Construction" to 30)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="LargeBlockInsetKitchen",
	humanName="Inset Kitchen",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=764.0,
	pcu=25,
	dlc="DecorativeBlocks3",
	components=mapOf("InteriorPlate" to 30, "Construction" to 30, "LargeTube" to 8, "Motor" to 6, "BulletproofGlass" to 6)
), BlockData(
	typeId="VendingMachine",
	xsiType="VendingMachine",
	subtypeId="FoodDispenser",
	humanName="Dispenser",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=318.0,
	pcu=10,
	dlc="DecorativeBlocks2",
	components=mapOf("InteriorPlate" to 20, "Construction" to 10, "Motor" to 4, "Display" to 10, "Computer" to 10)
), BlockData(
	typeId="Jukebox",
	xsiType="Jukebox",
	subtypeId="Jukebox",
	humanName="Jukebox",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=157.8,
	pcu=25,
	dlc="DecorativeBlocks2",
	components=mapOf("InteriorPlate" to 15, "Construction" to 10, "Computer" to 4, "Display" to 4)
), BlockData(
	typeId="LCDPanelsBlock",
	xsiType="LCDPanelsBlock",
	subtypeId="LabEquipment",
	humanName="Lab Equipment",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=249.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("InteriorPlate" to 15, "Construction" to 15, "Motor" to 1, "BulletproofGlass" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Shower",
	humanName="Shower",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=388.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "SmallTube" to 12, "BulletproofGlass" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowWall",
	humanName="Window Wall",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=390.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("SteelPlate" to 8, "Construction" to 10, "BulletproofGlass" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowWallLeft",
	humanName="Window Wall Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=400.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("SteelPlate" to 10, "Construction" to 10, "BulletproofGlass" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowWallRight",
	humanName="Window Wall Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=400.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("SteelPlate" to 10, "Construction" to 10, "BulletproofGlass" to 8)
), BlockData(
	typeId="LCDPanelsBlock",
	xsiType="LCDPanelsBlock",
	subtypeId="MedicalStation",
	humanName="Medical Station",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=379.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("InteriorPlate" to 15, "Construction" to 15, "Motor" to 2, "Medical" to 1, "Display" to 2)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="TransparentLCDLarge",
	humanName="Transparent LCD",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=295.2,
	pcu=50,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 8, "Computer" to 6, "Display" to 10, "BulletproofGlass" to 10)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="TransparentLCDSmall",
	humanName="Transparent LCD",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=71.8,
	pcu=50,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 4, "Computer" to 4, "Display" to 3, "BulletproofGlass" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Catwalk",
	humanName="Grated Catwalk",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=232.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 16, "Girder" to 4, "SmallTube" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="CatwalkCorner",
	humanName="Grated Catwalk Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=344.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 24, "Girder" to 4, "SmallTube" to 32)
), BlockData(
	typeId="CubeBlock",
	subtypeId="CatwalkStraight",
	humanName="Grated Catwalk Straight",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=344.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 24, "Girder" to 4, "SmallTube" to 32)
), BlockData(
	typeId="CubeBlock",
	subtypeId="CatwalkWall",
	humanName="Grated Catwalk Wall",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=288.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 20, "Girder" to 4, "SmallTube" to 26)
), BlockData(
	typeId="CubeBlock",
	subtypeId="CatwalkRailingEnd",
	humanName="Grated Catwalk End",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=400.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 28, "Girder" to 4, "SmallTube" to 38)
), BlockData(
	typeId="CubeBlock",
	subtypeId="CatwalkRailingHalfRight",
	humanName="Grated Catwalk Half Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=392.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 28, "Girder" to 4, "SmallTube" to 36)
), BlockData(
	typeId="CubeBlock",
	subtypeId="CatwalkRailingHalfLeft",
	humanName="Grated Catwalk Half Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=392.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 28, "Girder" to 4, "SmallTube" to 36)
), BlockData(
	typeId="CubeBlock",
	subtypeId="CatwalkHalf",
	humanName="Half Grated Catwalk",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=132.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 10, "Girder" to 2, "SmallTube" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="CatwalkHalfRailing",
	humanName="Half Grated Catwalk Straight",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=244.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 18, "Girder" to 2, "SmallTube" to 22)
), BlockData(
	typeId="CubeBlock",
	subtypeId="CatwalkHalfCenterRailing",
	humanName="Half Grated Catwalk Center Railing",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=188.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 14, "Girder" to 2, "SmallTube" to 16)
), BlockData(
	typeId="CubeBlock",
	subtypeId="CatwalkHalfOuterRailing",
	humanName="Half Grated Catwalk Railing",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=188.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 14, "Girder" to 2, "SmallTube" to 16)
), BlockData(
	typeId="CubeBlock",
	subtypeId="GratedStairs",
	humanName="Grated Stairs",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=272.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 22, "SmallTube" to 12, "InteriorPlate" to 16)
), BlockData(
	typeId="CubeBlock",
	subtypeId="GratedHalfStairs",
	humanName="Grated Half Stairs",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=208.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 20, "SmallTube" to 6, "InteriorPlate" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="GratedHalfStairsMirrored",
	humanName="Grated Half Stairs Mirrored",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=208.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 20, "SmallTube" to 6, "InteriorPlate" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="RailingStraight",
	humanName="Railing Straight",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=88.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 8, "SmallTube" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="RailingDouble",
	humanName="Railing Double",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=176.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 16, "SmallTube" to 12)
), BlockData(
	typeId="CubeBlock",
	subtypeId="RailingCorner",
	humanName="Railing Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=176.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 16, "SmallTube" to 12)
), BlockData(
	typeId="CubeBlock",
	subtypeId="RailingDiagonal",
	humanName="Railing Diagonal",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=132.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 12, "SmallTube" to 9)
), BlockData(
	typeId="CubeBlock",
	subtypeId="RailingHalfRight",
	humanName="Railing Half Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 8, "SmallTube" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="RailingHalfLeft",
	humanName="Railing Half Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 8, "SmallTube" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="RailingCenter",
	humanName="Railing Center",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=88.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 8, "SmallTube" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Railing2x1Right",
	humanName="Railing 2x1 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=108.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 10, "SmallTube" to 7)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Railing2x1Left",
	humanName="Railing 2x1 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=108.0,
	pcu=1,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 10, "SmallTube" to 7)
), BlockData(
	typeId="ReflectorLight",
	xsiType="ReflectorBlock",
	subtypeId="RotatingLightLarge",
	humanName="Rotating Light",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=48.0,
	pcu=25,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 3, "Motor" to 1)
), BlockData(
	typeId="ReflectorLight",
	xsiType="ReflectorBlock",
	subtypeId="RotatingLightSmall",
	humanName="Rotating Light",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=48.0,
	pcu=25,
	dlc="DecorativeBlocks2",
	components=mapOf("Construction" to 3, "Motor" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Freight1",
	humanName="Freight 1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=82.0,
	pcu=10,
	dlc="DecorativeBlocks2",
	components=mapOf("InteriorPlate" to 6, "Construction" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Freight2",
	humanName="Freight 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=164.0,
	pcu=10,
	dlc="DecorativeBlocks2",
	components=mapOf("InteriorPlate" to 12, "Construction" to 16)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Freight3",
	humanName="Freight 3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=246.0,
	pcu=10,
	dlc="DecorativeBlocks2",
	components=mapOf("InteriorPlate" to 18, "Construction" to 24)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorCornerSquare",
	humanName="Light Armor Corner Square Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=140.0,
	pcu=1,
	components=mapOf("SteelPlate" to 7)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorCornerSquare",
	humanName="Light Armor Corner Square Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorCornerSquare",
	humanName="Heavy Armor Corner Square Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=890.0,
	pcu=1,
	components=mapOf("SteelPlate" to 40, "MetalGrid" to 15)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorCornerSquare",
	humanName="Heavy Armor Corner Square Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorCornerSquareInverted",
	humanName="Light Armor Corner Square Inv. Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=380.0,
	pcu=1,
	components=mapOf("SteelPlate" to 19)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorCornerSquareInverted",
	humanName="Light Armor Corner Square Inv. Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorCornerSquareInverted",
	humanName="Heavy Armor Corner Square Inv. Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2480.0,
	pcu=1,
	components=mapOf("SteelPlate" to 112, "MetalGrid" to 40)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorCornerSquareInverted",
	humanName="Heavy Armor Corner Square Inv. Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=86.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorHalfCorner",
	humanName="Light Armor Half Corner Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=120.0,
	pcu=1,
	components=mapOf("SteelPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorHalfCorner",
	humanName="Light Armor Half Corner Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorHalfCorner",
	humanName="Heavy Armor Half Corner Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=872.0,
	pcu=1,
	components=mapOf("SteelPlate" to 40, "MetalGrid" to 12)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorHalfCorner",
	humanName="Heavy Armor Half Corner Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorHalfSlopeCorner",
	humanName="Half Slope Corner Light Armor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=40.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorHalfSlopeCorner",
	humanName="Half Slope Corner Light Armor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorHalfSlopeCorner",
	humanName="Half Slope Corner Heavy Armor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=264.0,
	pcu=1,
	components=mapOf("SteelPlate" to 12, "MetalGrid" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorHalfSlopeCorner",
	humanName="Half Slope Corner Heavy Armor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorHalfSlopeCornerInverted",
	humanName="Half Slope Corner Inv. Light Armor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=460.0,
	pcu=1,
	components=mapOf("SteelPlate" to 23)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorHalfSlopeCornerInverted",
	humanName="Half Slope Corner Inv. Light Armor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorHalfSlopeCornerInverted",
	humanName="Half Slope Corner Inv. Heavy Armor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=3050.0,
	pcu=1,
	components=mapOf("SteelPlate" to 139, "MetalGrid" to 45)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorHalfSlopeCornerInverted",
	humanName="Half Slope Corner Inv. Heavy Armor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=106.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorHalfSlopedCorner",
	humanName="Light Armor Half Sloped Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=220.0,
	pcu=1,
	components=mapOf("SteelPlate" to 11)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorHalfSlopedCorner",
	humanName="Light Armor Half Sloped Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorHalfSlopedCorner",
	humanName="Heavy Armor Half Sloped Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=930.0,
	pcu=1,
	components=mapOf("SteelPlate" to 45, "MetalGrid" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorHalfSlopedCorner",
	humanName="Heavy Armor Half Sloped Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorHalfSlopedCornerBase",
	humanName="Light Armor Half Sloped Corner Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=220.0,
	pcu=1,
	components=mapOf("SteelPlate" to 11)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorHalfSlopedCornerBase",
	humanName="Light Armor Half Sloped Corner Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorHalfSlopedCornerBase",
	humanName="Heavy Armor Half Sloped Corner Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=990.0,
	pcu=1,
	components=mapOf("SteelPlate" to 45, "MetalGrid" to 15)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorHalfSlopedCornerBase",
	humanName="Heavy Armor Half Sloped Corner Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorHalfSlopeInverted",
	humanName="Half Slope Inv. Light Armor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=440.0,
	pcu=1,
	components=mapOf("SteelPlate" to 22)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorHalfSlopeInverted",
	humanName="Half Slope Inv. Light Armor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorHalfSlopeInverted",
	humanName="Half Slope Inv. Heavy Armor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2930.0,
	pcu=1,
	components=mapOf("SteelPlate" to 133, "MetalGrid" to 45)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorHalfSlopeInverted",
	humanName="Half Slope Inv. Heavy Armor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=106.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlopedCorner",
	humanName="Light Armor Sloped Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=260.0,
	pcu=1,
	components=mapOf("SteelPlate" to 13)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlopedCorner",
	humanName="Light Armor Sloped Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSlopedCorner",
	humanName="Heavy Armor Sloped Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1650.0,
	pcu=1,
	components=mapOf("SteelPlate" to 75, "MetalGrid" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSlopedCorner",
	humanName="Heavy Armor Sloped Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlopedCornerBase",
	humanName="Light Armor Sloped Corner Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=400.0,
	pcu=1,
	components=mapOf("SteelPlate" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlopedCornerBase",
	humanName="Light Armor Sloped Corner Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSlopedCornerBase",
	humanName="Heavy Armor Sloped Corner Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2780.0,
	pcu=1,
	components=mapOf("SteelPlate" to 127, "MetalGrid" to 40)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSlopedCornerBase",
	humanName="Heavy Armor Sloped Corner Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=106.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlopedCornerTip",
	humanName="Sloped Corner Light Armor Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlopedCornerTip",
	humanName="Sloped Corner Light Armor Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSlopedCornerTip",
	humanName="Sloped Corner Heavy Armor Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=496.0,
	pcu=1,
	components=mapOf("SteelPlate" to 23, "MetalGrid" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSlopedCornerTip",
	humanName="Sloped Corner Heavy Armor Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockDesk",
	humanName="Desk",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=330.0,
	pcu=15,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 30, "Construction" to 30)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockDeskCorner",
	humanName="Desk Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=220.0,
	pcu=15,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockDeskCornerInv",
	humanName="Desk Corner Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=660.0,
	pcu=15,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 60, "Construction" to 60)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockDeskChairless",
	humanName="Chairless Desk",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=330.0,
	pcu=1,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 30, "Construction" to 30)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockDeskChairlessCorner",
	humanName="Chairless Desk Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=220.0,
	pcu=1,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockDeskChairlessCornerInv",
	humanName="Chairless Desk Corner Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=660.0,
	pcu=1,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 60, "Construction" to 60)
), BlockData(
	typeId="Kitchen",
	xsiType="Kitchen",
	subtypeId="LargeBlockKitchen",
	humanName="Kitchen",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=654.0,
	pcu=1,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "LargeTube" to 6, "Motor" to 6, "BulletproofGlass" to 4)
), BlockData(
	typeId="CryoChamber",
	xsiType="CryoChamber",
	subtypeId="LargeBlockBed",
	humanName="Bed",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=512.0,
	pcu=15,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 30, "Construction" to 30, "SmallTube" to 8, "BulletproofGlass" to 10)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="LargeBlockLockerRoom",
	humanName="Armory",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=512.0,
	pcu=10,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 30, "Construction" to 30, "Display" to 4, "BulletproofGlass" to 10)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="LargeBlockLockerRoomCorner",
	humanName="Armory Lockers",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=497.0,
	pcu=10,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 25, "Construction" to 30, "Display" to 4, "BulletproofGlass" to 10)
), BlockData(
	typeId="Planter",
	xsiType="Planter",
	subtypeId="LargeBlockPlanters",
	humanName="Planters",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=342.0,
	pcu=1,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 10, "Construction" to 20, "SmallTube" to 8, "BulletproofGlass" to 8)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockCouch",
	humanName="Couch",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=330.0,
	pcu=15,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 30, "Construction" to 30)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockCouchCorner",
	humanName="Corner Couch",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=385.0,
	pcu=15,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 35, "Construction" to 35)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="LargeBlockLockers",
	humanName="Lockers",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=244.4,
	pcu=10,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "Display" to 3, "Computer" to 2)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockBathroomOpen",
	humanName="Toilet",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=508.0,
	pcu=15,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 30, "Construction" to 30, "SmallTube" to 8, "Motor" to 4, "LargeTube" to 2)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockBathroom",
	humanName="Bathroom",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=588.0,
	pcu=15,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 30, "Construction" to 40, "SmallTube" to 8, "Motor" to 4, "LargeTube" to 2)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockToilet",
	humanName="Toilet Seat",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=231.0,
	pcu=15,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 10, "Construction" to 15, "SmallTube" to 2, "Motor" to 2, "LargeTube" to 1)
), BlockData(
	typeId="Projector",
	xsiType="Projector",
	subtypeId="LargeBlockConsole",
	humanName="Console Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=381.6,
	pcu=150,
	dlc="DecorativeBlocks",
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "Computer" to 8, "Display" to 10)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="SmallBlockCockpitIndustrial",
	humanName="Industrial Cockpit",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 4, 4),
	mass=1460.0,
	pcu=150,
	dlc="DecorativeBlocks",
	components=mapOf("SteelPlate" to 10, "Construction" to 20, "MetalGrid" to 10, "Motor" to 2, "Display" to 6, "Computer" to 20, "BulletproofGlass" to 60, "SmallTube" to 10)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockCockpitIndustrial",
	humanName="Industrial Cockpit",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2110.0,
	pcu=150,
	dlc="DecorativeBlocks",
	components=mapOf("SteelPlate" to 20, "Construction" to 30, "MetalGrid" to 15, "Motor" to 2, "Display" to 10, "Computer" to 60, "BulletproofGlass" to 80, "SmallTube" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeRailStraight",
	humanName="LargeRailStraight",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=404.0,
	pcu=1,
	components=mapOf("SteelPlate" to 12, "Construction" to 8, "LargeTube" to 4)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="LargeBlockWeaponRack",
	humanName="Weapon Rack",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=250.0,
	pcu=10,
	dlc="Warfare1",
	components=mapOf("InteriorPlate" to 30, "Construction" to 20)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="SmallBlockWeaponRack",
	humanName="Weapon Rack",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=33.0,
	pcu=10,
	dlc="Warfare1",
	components=mapOf("InteriorPlate" to 3, "Construction" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="FireCover",
	humanName="Fire Cover",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=160.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("SteelPlate" to 4, "Construction" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="FireCoverCorner",
	humanName="Fire Cover Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=320.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("SteelPlate" to 8, "Construction" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="HalfWindow",
	humanName="Half Window",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=374.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("Girder" to 4, "SteelPlate" to 10, "BulletproofGlass" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="HalfWindowInv",
	humanName="Half Window Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=374.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("Girder" to 4, "SteelPlate" to 10, "BulletproofGlass" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="HalfWindowCorner",
	humanName="Half Window Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=748.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("Girder" to 8, "SteelPlate" to 20, "BulletproofGlass" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="HalfWindowCornerInv",
	humanName="Half Window Corner Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=748.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("Girder" to 8, "SteelPlate" to 20, "BulletproofGlass" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="HalfWindowDiagonal",
	humanName="Half Window Diagonal",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=526.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("Girder" to 6, "SteelPlate" to 14, "BulletproofGlass" to 14)
), BlockData(
	typeId="CubeBlock",
	subtypeId="HalfWindowRound",
	humanName="Half Window Round",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=632.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("Girder" to 7, "SteelPlate" to 16, "BulletproofGlass" to 18)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Embrasure",
	humanName="Embrasure",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=820.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("SteelPlate" to 30, "Construction" to 20, "MetalGrid" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="PassageSciFi",
	humanName="Passage 3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=574.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("InteriorPlate" to 74, "Construction" to 20, "SmallTube" to 48)
), BlockData(
	typeId="CubeBlock",
	subtypeId="PassageSciFiWall",
	humanName="Passage 3 Wall",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=390.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("InteriorPlate" to 50, "Construction" to 14, "SmallTube" to 32)
), BlockData(
	typeId="CubeBlock",
	subtypeId="PassageSciFiIntersection",
	humanName="Passage 3 Cross",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=285.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("InteriorPlate" to 35, "Construction" to 10, "SmallTube" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="PassageSciFiGate",
	humanName="Passage 3 Frame",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=285.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("InteriorPlate" to 35, "Construction" to 10, "SmallTube" to 25)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="PassageSciFiLight",
	humanName="Passage 3 Light",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=574.0,
	pcu=25,
	dlc="Warfare1",
	components=mapOf("InteriorPlate" to 74, "Construction" to 20, "SmallTube" to 48)
), BlockData(
	typeId="CubeBlock",
	subtypeId="PassageScifiCorner",
	humanName="Passage 3 Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=574.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("InteriorPlate" to 74, "Construction" to 20, "SmallTube" to 48)
), BlockData(
	typeId="CubeBlock",
	subtypeId="PassageSciFiTjunction",
	humanName="Passage 3 T-junction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=445.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("InteriorPlate" to 55, "Construction" to 16, "SmallTube" to 38)
), BlockData(
	typeId="CubeBlock",
	subtypeId="PassageSciFiWindow",
	humanName="Passage 3 Windowed",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=700.0,
	pcu=1,
	dlc="Warfare1",
	components=mapOf("InteriorPlate" to 60, "Construction" to 16, "BulletproofGlass" to 16, "SmallTube" to 38)
), BlockData(
	typeId="Door",
	xsiType="Door",
	subtypeId="",
	humanName="Door",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=582.4,
	pcu=115,
	components=mapOf("InteriorPlate" to 10, "Construction" to 40, "SmallTube" to 4, "Motor" to 2, "Display" to 1, "Computer" to 2, "SteelPlate" to 8)
), BlockData(
	typeId="Door",
	xsiType="Door",
	subtypeId="SmallDoor",
	humanName="Door",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 4, 1),
	mass=456.4,
	pcu=115,
	components=mapOf("InteriorPlate" to 8, "Construction" to 30, "SmallTube" to 4, "Motor" to 2, "Display" to 1, "Computer" to 2, "SteelPlate" to 6)
), BlockData(
	typeId="AirtightHangarDoor",
	xsiType="AirtightHangarDoor",
	subtypeId="",
	humanName="Airtight Hangar Door",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 3, 1),
	mass=7864.4,
	pcu=115,
	components=mapOf("SteelPlate" to 350, "Construction" to 40, "SmallTube" to 40, "Motor" to 16, "Computer" to 2)
), BlockData(
	typeId="AirtightSlideDoor",
	xsiType="AirtightSlideDoor",
	subtypeId="LargeBlockSlideDoor",
	humanName="Sliding Door",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1065.4,
	pcu=115,
	components=mapOf("SteelPlate" to 20, "Construction" to 40, "SmallTube" to 4, "Motor" to 4, "Display" to 1, "Computer" to 2, "BulletproofGlass" to 15)
), BlockData(
	typeId="CubeBlock",
	subtypeId="ArmorCenter",
	humanName="Blast Doors",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2800.0,
	pcu=1,
	components=mapOf("SteelPlate" to 140)
), BlockData(
	typeId="CubeBlock",
	subtypeId="ArmorCorner",
	humanName="Blast Door Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2400.0,
	pcu=1,
	components=mapOf("SteelPlate" to 120)
), BlockData(
	typeId="CubeBlock",
	subtypeId="ArmorInvCorner",
	humanName="Blast Door Corner Inverted",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2700.0,
	pcu=1,
	components=mapOf("SteelPlate" to 135)
), BlockData(
	typeId="CubeBlock",
	subtypeId="ArmorSide",
	humanName="Blast Door Edge",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2600.0,
	pcu=1,
	components=mapOf("SteelPlate" to 130)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorCenter",
	humanName="Blast Doors",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorCorner",
	humanName="Blast Door Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorInvCorner",
	humanName="Blast Door Corner Inverted",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallArmorSide",
	humanName="Blast Door Edge",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="Warhead",
	xsiType="Warhead",
	subtypeId="LargeWarhead",
	humanName="Warhead",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=700.4,
	pcu=100,
	components=mapOf("SteelPlate" to 20, "Girder" to 24, "Construction" to 12, "SmallTube" to 12, "Computer" to 2, "Explosives" to 6)
), BlockData(
	typeId="Warhead",
	xsiType="Warhead",
	subtypeId="SmallWarhead",
	humanName="Warhead",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=106.2,
	pcu=50,
	components=mapOf("SteelPlate" to 4, "Girder" to 1, "Construction" to 1, "SmallTube" to 2, "Computer" to 1, "Explosives" to 2)
), BlockData(
	typeId="Decoy",
	xsiType="Decoy",
	subtypeId="LargeDecoy",
	humanName="Decoy",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=740.0,
	pcu=50,
	components=mapOf("SteelPlate" to 30, "Construction" to 10, "Computer" to 10, "RadioCommunication" to 1, "LargeTube" to 2)
), BlockData(
	typeId="Decoy",
	xsiType="Decoy",
	subtypeId="SmallDecoy",
	humanName="Decoy",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=64.2,
	pcu=50,
	components=mapOf("SteelPlate" to 2, "Construction" to 1, "Computer" to 1, "RadioCommunication" to 1, "SmallTube" to 2)
), BlockData(
	typeId="LargeGatlingTurret",
	xsiType="LargeTurretBase",
	subtypeId="",
	humanName="Gatling Turret",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=1428.0,
	pcu=225,
	components=mapOf("SteelPlate" to 40, "Construction" to 40, "MetalGrid" to 15, "SmallTube" to 6, "Motor" to 8, "Computer" to 10)
), BlockData(
	typeId="LargeGatlingTurret",
	xsiType="LargeTurretBase",
	subtypeId="SmallGatlingTurret",
	humanName="Gatling Turret",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 5, 5),
	mass=692.0,
	pcu=225,
	components=mapOf("SteelPlate" to 15, "Construction" to 30, "MetalGrid" to 5, "SmallTube" to 6, "Motor" to 4, "Computer" to 10)
), BlockData(
	typeId="LargeMissileTurret",
	xsiType="LargeTurretBase",
	subtypeId="",
	humanName="Rocket Turret",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=1826.0,
	pcu=275,
	components=mapOf("SteelPlate" to 40, "Construction" to 50, "MetalGrid" to 15, "LargeTube" to 6, "Motor" to 16, "Computer" to 10)
), BlockData(
	typeId="LargeMissileTurret",
	xsiType="LargeTurretBase",
	subtypeId="SmallMissileTurret",
	humanName="Rocket Turret",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 5, 5),
	mass=894.0,
	pcu=100,
	components=mapOf("SteelPlate" to 15, "Construction" to 40, "MetalGrid" to 5, "LargeTube" to 2, "Motor" to 8, "Computer" to 10)
), BlockData(
	typeId="InteriorTurret",
	xsiType="LargeTurretBase",
	subtypeId="LargeInteriorTurret",
	humanName="Interior Turret",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=311.0,
	pcu=125,
	components=mapOf("InteriorPlate" to 6, "Construction" to 20, "SmallTube" to 1, "Motor" to 2, "Computer" to 5, "SteelPlate" to 4)
), BlockData(
	typeId="SmallMissileLauncher",
	xsiType="WeaponBlock",
	subtypeId="",
	humanName="Rocket Launcher",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 4),
	mass=226.2,
	pcu=425,
	components=mapOf("SteelPlate" to 4, "Construction" to 2, "MetalGrid" to 1, "LargeTube" to 4, "Motor" to 1, "Computer" to 1)
), BlockData(
	typeId="SmallMissileLauncher",
	xsiType="WeaponBlock",
	subtypeId="LargeMissileLauncher",
	humanName="Rocket Launcher",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=1713.8,
	pcu=825,
	components=mapOf("SteelPlate" to 35, "Construction" to 8, "MetalGrid" to 30, "LargeTube" to 25, "Motor" to 6, "Computer" to 4)
), BlockData(
	typeId="SmallMissileLauncherReload",
	xsiType="WeaponBlock",
	subtypeId="SmallRocketLauncherReload",
	humanName="Reloadable Rocket Launcher",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 3, 3),
	mass=1058.4,
	pcu=425,
	components=mapOf("SmallTube" to 50, "InteriorPlate" to 50, "Construction" to 24, "LargeTube" to 8, "MetalGrid" to 10, "Motor" to 4, "Computer" to 2, "SteelPlate" to 8)
), BlockData(
	typeId="SmallGatlingGun",
	xsiType="WeaponBlock",
	subtypeId="",
	humanName="Gatling Gun",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 4),
	mass=148.2,
	pcu=80,
	components=mapOf("SteelPlate" to 4, "Construction" to 1, "MetalGrid" to 2, "SmallTube" to 6, "Motor" to 1, "Computer" to 1)
), BlockData(
	typeId="SmallGatlingGun",
	xsiType="WeaponBlock",
	subtypeId="SmallBlockAutocannon",
	humanName="Autocannon",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 5),
	mass=180.2,
	pcu=80,
	components=mapOf("SteelPlate" to 6, "Construction" to 2, "MetalGrid" to 2, "SmallTube" to 2, "Motor" to 1, "Computer" to 1)
), BlockData(
	typeId="SmallMissileLauncherReload",
	xsiType="WeaponBlock",
	subtypeId="SmallBlockMediumCalibreGun",
	humanName="Assault Cannon",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 9),
	mass=860.2,
	pcu=80,
	components=mapOf("SteelPlate" to 25, "Construction" to 10, "MetalGrid" to 5, "LargeTube" to 10, "Computer" to 1)
), BlockData(
	typeId="SmallMissileLauncher",
	xsiType="WeaponBlock",
	subtypeId="LargeBlockLargeCalibreGun",
	humanName="Artillery",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 4),
	mass=5781.0,
	pcu=80,
	components=mapOf("SteelPlate" to 250, "Construction" to 20, "MetalGrid" to 20, "LargeTube" to 20, "Computer" to 5)
), BlockData(
	typeId="SmallMissileLauncherReload",
	xsiType="WeaponBlock",
	subtypeId="LargeRailgun",
	humanName="Railgun",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 8),
	mass=14470.0,
	pcu=80,
	components=mapOf("SteelPlate" to 350, "Construction" to 150, "Superconductor" to 150, "LargeTube" to 60, "PowerCell" to 100, "Computer" to 100)
), BlockData(
	typeId="SmallMissileLauncherReload",
	xsiType="WeaponBlock",
	subtypeId="SmallRailgun",
	humanName="Railgun",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 8),
	mass=1364.0,
	pcu=80,
	components=mapOf("SteelPlate" to 25, "Construction" to 20, "Superconductor" to 20, "LargeTube" to 6, "PowerCell" to 10, "Computer" to 20)
), BlockData(
	typeId="LargeMissileTurret",
	xsiType="LargeTurretBase",
	subtypeId="LargeCalibreTurret",
	humanName="Artillery Turret",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=14224.0,
	pcu=275,
	components=mapOf("SteelPlate" to 450, "Construction" to 400, "MetalGrid" to 50, "LargeTube" to 40, "Motor" to 30, "Computer" to 20)
), BlockData(
	typeId="LargeMissileTurret",
	xsiType="LargeTurretBase",
	subtypeId="LargeBlockMediumCalibreTurret",
	humanName="Assault Cannon Turret",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 2, 3),
	mass=9654.0,
	pcu=275,
	components=mapOf("SteelPlate" to 300, "Construction" to 280, "MetalGrid" to 30, "LargeTube" to 30, "Motor" to 20, "Computer" to 20)
), BlockData(
	typeId="LargeMissileTurret",
	xsiType="LargeTurretBase",
	subtypeId="SmallBlockMediumCalibreTurret",
	humanName="Assault Cannon Turret",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(7, 5, 7),
	mass=2254.0,
	pcu=275,
	components=mapOf("SteelPlate" to 50, "Construction" to 100, "MetalGrid" to 10, "LargeTube" to 6, "Motor" to 10, "Computer" to 20)
), BlockData(
	typeId="LargeGatlingTurret",
	xsiType="LargeTurretBase",
	subtypeId="AutoCannonTurret",
	humanName="Autocannon Turret",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 4, 5),
	mass=870.0,
	pcu=225,
	components=mapOf("SteelPlate" to 20, "Construction" to 40, "MetalGrid" to 6, "SmallTube" to 4, "Motor" to 4, "Computer" to 10)
), BlockData(
	typeId="SmallMissileLauncher",
	xsiType="WeaponBlock",
	subtypeId="LargeFlareLauncher",
	humanName="Firework Launcher",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=730.8,
	pcu=150,
	components=mapOf("SteelPlate" to 20, "Construction" to 10, "LargeTube" to 10, "Computer" to 4)
), BlockData(
	typeId="SmallMissileLauncher",
	xsiType="WeaponBlock",
	subtypeId="SmallFlareLauncher",
	humanName="Firework Launcher",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=123.2,
	pcu=150,
	components=mapOf("SteelPlate" to 2, "Construction" to 1, "LargeTube" to 3, "Computer" to 1)
), BlockData(
	typeId="MedicalRoom",
	xsiType="MedicalRoom",
	subtypeId="LargeMedicalRoom",
	humanName="Medical Room",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 2),
	mass=4257.0,
	pcu=30,
	components=mapOf("InteriorPlate" to 240, "Construction" to 80, "MetalGrid" to 60, "SmallTube" to 20, "LargeTube" to 5, "Display" to 10, "Computer" to 10, "Medical" to 15)
), BlockData(
	typeId="CryoChamber",
	xsiType="CryoChamber",
	subtypeId="LargeBlockCryoChamber",
	humanName="Cryo Chamber",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1142.0,
	pcu=15,
	components=mapOf("InteriorPlate" to 40, "Construction" to 20, "Motor" to 8, "Display" to 8, "Medical" to 3, "Computer" to 30, "BulletproofGlass" to 10)
), BlockData(
	typeId="CryoChamber",
	xsiType="CryoChamber",
	subtypeId="SmallBlockCryoChamber",
	humanName="Cryo Chamber",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 4, 3),
	mass=796.0,
	pcu=15,
	components=mapOf("InteriorPlate" to 20, "Construction" to 10, "Motor" to 4, "Display" to 4, "Medical" to 3, "Computer" to 15, "BulletproofGlass" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="BridgeWindow1x1Slope",
	humanName="Bridge Window Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=553.0,
	pcu=1,
	dlc="Warfare2",
	components=mapOf("Girder" to 8, "SteelPlate" to 5, "InteriorPlate" to 10, "BulletproofGlass" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="BridgeWindow1x1Face",
	humanName="Bridge Window Face",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=370.0,
	pcu=1,
	dlc="Warfare2",
	components=mapOf("Girder" to 8, "SteelPlate" to 2, "InteriorPlate" to 4, "BulletproofGlass" to 18)
), BlockData(
	typeId="CubeBlock",
	subtypeId="BridgeWindow1x1FaceInverted",
	humanName="Bridge Window Face Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=366.0,
	pcu=1,
	dlc="Warfare2",
	components=mapOf("Girder" to 5, "SteelPlate" to 6, "InteriorPlate" to 12, "BulletproofGlass" to 12)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="PassengerBench",
	humanName="Passenger Bench",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 2),
	mass=220.0,
	pcu=15,
	dlc="Warfare2",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="LargeLightPanel",
	humanName="Light Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=95.0,
	pcu=25,
	dlc="Warfare2",
	components=mapOf("Construction" to 10, "InteriorPlate" to 5)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="SmallLightPanel",
	humanName="Light Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=25,
	dlc="Warfare2",
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="Reactor",
	xsiType="Reactor",
	subtypeId="LargeBlockSmallGeneratorWarfare2",
	humanName="Small Warfare Reactor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=4793.0,
	pcu=25,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 80, "Construction" to 40, "MetalGrid" to 4, "LargeTube" to 8, "Reactor" to 100, "Motor" to 6, "Computer" to 25)
), BlockData(
	typeId="Reactor",
	xsiType="Reactor",
	subtypeId="LargeBlockLargeGeneratorWarfare2",
	humanName="Large Warfare Reactor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=73795.0,
	pcu=25,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 1000, "Construction" to 70, "MetalGrid" to 40, "LargeTube" to 40, "Superconductor" to 100, "Reactor" to 2000, "Motor" to 20, "Computer" to 75)
), BlockData(
	typeId="Reactor",
	xsiType="Reactor",
	subtypeId="SmallBlockSmallGeneratorWarfare2",
	humanName="Small Warfare Reactor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=278.0,
	pcu=25,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 3, "Construction" to 10, "MetalGrid" to 2, "LargeTube" to 1, "Reactor" to 3, "Motor" to 1, "Computer" to 10)
), BlockData(
	typeId="Reactor",
	xsiType="Reactor",
	subtypeId="SmallBlockLargeGeneratorWarfare2",
	humanName="Large Warfare Reactor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=3901.0,
	pcu=25,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 60, "Construction" to 9, "MetalGrid" to 9, "LargeTube" to 3, "Reactor" to 95, "Motor" to 5, "Computer" to 25)
), BlockData(
	typeId="AirtightHangarDoor",
	xsiType="AirtightHangarDoor",
	subtypeId="AirtightHangarDoorWarfare2A",
	humanName="Warfare Hangar Door",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 3, 1),
	mass=7864.4,
	pcu=115,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 350, "Construction" to 40, "SmallTube" to 40, "Motor" to 16, "Computer" to 2)
), BlockData(
	typeId="AirtightHangarDoor",
	xsiType="AirtightHangarDoor",
	subtypeId="AirtightHangarDoorWarfare2B",
	humanName="Warfare Hangar Door Windowed",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 3, 1),
	mass=7864.4,
	pcu=115,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 350, "Construction" to 40, "SmallTube" to 40, "Motor" to 16, "Computer" to 2)
), BlockData(
	typeId="AirtightHangarDoor",
	xsiType="AirtightHangarDoor",
	subtypeId="AirtightHangarDoorWarfare2C",
	humanName="Warfare Hangar Door 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 3, 1),
	mass=7864.4,
	pcu=115,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 350, "Construction" to 40, "SmallTube" to 40, "Motor" to 16, "Computer" to 2)
), BlockData(
	typeId="SmallMissileLauncher",
	xsiType="WeaponBlock",
	subtypeId="SmallMissileLauncherWarfare2",
	humanName="Warfare Rocket Launcher",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 4),
	mass=226.2,
	pcu=425,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 4, "Construction" to 2, "MetalGrid" to 1, "LargeTube" to 4, "Motor" to 1, "Computer" to 1)
), BlockData(
	typeId="SmallGatlingGun",
	xsiType="WeaponBlock",
	subtypeId="SmallGatlingGunWarfare2",
	humanName="Warfare Gatling Gun",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 4),
	mass=148.2,
	pcu=80,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 4, "Construction" to 1, "MetalGrid" to 2, "SmallTube" to 6, "Motor" to 1, "Computer" to 1)
), BlockData(
	typeId="BatteryBlock",
	xsiType="BatteryBlock",
	subtypeId="LargeBlockBatteryBlockWarfare2",
	humanName="Warfare Battery",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=3845.0,
	pcu=15,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 80, "Construction" to 30, "PowerCell" to 80, "Computer" to 25)
), BlockData(
	typeId="BatteryBlock",
	xsiType="BatteryBlock",
	subtypeId="SmallBlockBatteryBlockWarfare2",
	humanName="Warfare Battery",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 2, 3),
	mass=1040.4,
	pcu=15,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 25, "Construction" to 5, "PowerCell" to 20, "Computer" to 2)
), BlockData(
	typeId="Door",
	xsiType="Door",
	subtypeId="SlidingHatchDoor",
	humanName="Sliding Hatch Door",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 1),
	mass=1502.4,
	pcu=115,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 40, "Construction" to 50, "SmallTube" to 10, "Motor" to 4, "Display" to 2, "Computer" to 2, "BulletproofGlass" to 10)
), BlockData(
	typeId="Door",
	xsiType="Door",
	subtypeId="SlidingHatchDoorHalf",
	humanName="Half Sliding Hatch Door",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 1),
	mass=1302.4,
	pcu=115,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 30, "Construction" to 50, "SmallTube" to 10, "Motor" to 4, "Display" to 2, "Computer" to 2, "BulletproofGlass" to 10)
), BlockData(
	typeId="Searchlight",
	xsiType="Searchlight",
	subtypeId="SmallSearchlight",
	humanName="Searchlight",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=148.0,
	pcu=50,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 1, "Construction" to 3, "LargeTube" to 1, "Motor" to 2, "Computer" to 5, "BulletproofGlass" to 2)
), BlockData(
	typeId="Searchlight",
	xsiType="Searchlight",
	subtypeId="LargeSearchlight",
	humanName="Searchlight",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=467.0,
	pcu=50,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 5, "Construction" to 20, "LargeTube" to 2, "Motor" to 4, "Computer" to 5, "BulletproofGlass" to 4)
), BlockData(
	typeId="HeatVentBlock",
	xsiType="HeatVentBlock",
	subtypeId="LargeHeatVentBlock",
	humanName="Heat Vent",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1030.0,
	pcu=50,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 25, "Construction" to 20, "LargeTube" to 10, "Motor" to 5)
), BlockData(
	typeId="HeatVentBlock",
	xsiType="HeatVentBlock",
	subtypeId="SmallHeatVentBlock",
	humanName="Heat Vent",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=97.0,
	pcu=50,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 2, "Construction" to 1, "LargeTube" to 1, "Motor" to 1)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="SmallBlockStandingCockpit",
	humanName="Helm",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 4, 3),
	mass=264.0,
	pcu=50,
	dlc="Warfare2",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "Motor" to 1, "Computer" to 20, "Display" to 2)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockStandingCockpit",
	humanName="Helm",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=264.0,
	pcu=50,
	dlc="Warfare2",
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "Motor" to 1, "Computer" to 20, "Display" to 2)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockSmallModularThruster",
	humanName="Warfare Ion Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=121.0,
	pcu=15,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 2, "Construction" to 2, "LargeTube" to 1, "Thrust" to 1)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockLargeModularThruster",
	humanName="Large Warfare Ion Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 4),
	mass=721.0,
	pcu=15,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 5, "Construction" to 2, "LargeTube" to 5, "Thrust" to 12)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockSmallModularThruster",
	humanName="Warfare Ion Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=4380.0,
	pcu=15,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 25, "Construction" to 60, "LargeTube" to 8, "Thrust" to 80)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockLargeModularThruster",
	humanName="Large Warfare Ion Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 3, 4),
	mass=43200.0,
	pcu=15,
	dlc="Warfare2",
	components=mapOf("SteelPlate" to 150, "Construction" to 100, "LargeTube" to 40, "Thrust" to 960)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolA",
	humanName="Letter A",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolB",
	humanName="Letter B",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolC",
	humanName="Letter C",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolD",
	humanName="Letter D",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolE",
	humanName="Letter E",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolF",
	humanName="Letter F",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolG",
	humanName="Letter G",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolH",
	humanName="Letter H",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolI",
	humanName="Letter I",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolJ",
	humanName="Letter J",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolK",
	humanName="Letter K",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolL",
	humanName="Letter L",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolM",
	humanName="Letter M",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolN",
	humanName="Letter N",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolO",
	humanName="Letter O",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolP",
	humanName="Letter P",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolQ",
	humanName="Letter Q",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolR",
	humanName="Letter R",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolS",
	humanName="Letter S",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolT",
	humanName="Letter T",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolU",
	humanName="Letter U",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolV",
	humanName="Letter V",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolW",
	humanName="Letter W",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolX",
	humanName="Letter X",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolY",
	humanName="Letter Y",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolZ",
	humanName="Letter Z",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolA",
	humanName="Letter A",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolB",
	humanName="Letter B",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolC",
	humanName="Letter C",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolD",
	humanName="Letter D",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolE",
	humanName="Letter E",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolF",
	humanName="Letter F",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolG",
	humanName="Letter G",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolH",
	humanName="Letter H",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolI",
	humanName="Letter I",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolJ",
	humanName="Letter J",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolK",
	humanName="Letter K",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolL",
	humanName="Letter L",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolM",
	humanName="Letter M",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolN",
	humanName="Letter N",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolO",
	humanName="Letter O",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolP",
	humanName="Letter P",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolQ",
	humanName="Letter Q",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolR",
	humanName="Letter R",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolS",
	humanName="Letter S",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolT",
	humanName="Letter T",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolU",
	humanName="Letter U",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolV",
	humanName="Letter V",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolW",
	humanName="Letter W",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolX",
	humanName="Letter X",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolY",
	humanName="Letter Y",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolZ",
	humanName="Letter Z",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbol0",
	humanName="Number 0",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbol1",
	humanName="Number 1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbol2",
	humanName="Number 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbol3",
	humanName="Number 3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbol4",
	humanName="Number 4",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbol5",
	humanName="Number 5",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbol6",
	humanName="Number 6",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbol7",
	humanName="Number 7",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbol8",
	humanName="Number 8",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbol9",
	humanName="Number 9",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbol0",
	humanName="Number 0",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbol1",
	humanName="Number 1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbol2",
	humanName="Number 2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbol3",
	humanName="Number 3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbol4",
	humanName="Number 4",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbol5",
	humanName="Number 5",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbol6",
	humanName="Number 6",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbol7",
	humanName="Number 7",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbol8",
	humanName="Number 8",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbol9",
	humanName="Number 9",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolHyphen",
	humanName="Hyphen",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolUnderscore",
	humanName="Underscore",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolDot",
	humanName="Dot",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolApostrophe",
	humanName="Apostrophe",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolAnd",
	humanName="And",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolColon",
	humanName="Colon",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolExclamationMark",
	humanName="Exclamationmark",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeSymbolQuestionMark",
	humanName="Questionmark",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolHyphen",
	humanName="Hyphen",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolUnderscore",
	humanName="Underscore",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolDot",
	humanName="Dot",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolApostrophe",
	humanName="Apostrophe",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolAnd",
	humanName="And",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolColon",
	humanName="Colon",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolExclamationMark",
	humanName="Exclamationmark",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallSymbolQuestionMark",
	humanName="Questionmark",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="ControlPanel",
	humanName="Control Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=36.2,
	pcu=5,
	components=mapOf("SteelPlate" to 1, "Construction" to 1, "Computer" to 1, "Display" to 1)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="SmallControlPanel",
	humanName="Control Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.2,
	pcu=5,
	components=mapOf("SteelPlate" to 1, "Construction" to 1, "Computer" to 1, "Display" to 1)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="LargeControlPanelPedestal",
	humanName="Control Panel Pedestal",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=103.2,
	pcu=5,
	components=mapOf("InteriorPlate" to 5, "Construction" to 10, "Computer" to 1, "Display" to 1)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="SmallControlPanelPedestal",
	humanName="Control Panel Pedestal",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 3, 1),
	mass=103.2,
	pcu=5,
	components=mapOf("InteriorPlate" to 5, "Construction" to 10, "Computer" to 1, "Display" to 1)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockCockpit",
	humanName="Control Station",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=368.0,
	pcu=50,
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "Motor" to 2, "Computer" to 100, "Display" to 10)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="LargeBlockCockpitSeat",
	humanName="Cockpit",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1768.0,
	pcu=150,
	components=mapOf("SteelPlate" to 30, "Construction" to 20, "Motor" to 1, "Display" to 8, "Computer" to 100, "BulletproofGlass" to 60)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="SmallBlockCockpit",
	humanName="Cockpit",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=797.0,
	pcu=150,
	components=mapOf("SteelPlate" to 10, "Construction" to 10, "Motor" to 1, "Display" to 5, "Computer" to 15, "BulletproofGlass" to 30)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="DBSmallBlockFighterCockpit",
	humanName="Fighter Cockpit",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 4, 6),
	mass=1325.0,
	pcu=150,
	components=mapOf("Construction" to 20, "Motor" to 1, "SteelPlate" to 20, "MetalGrid" to 10, "InteriorPlate" to 15, "Display" to 4, "Computer" to 20, "BulletproofGlass" to 40)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="CockpitOpen",
	humanName="Flight Seat",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=320.0,
	pcu=50,
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "Motor" to 2, "Computer" to 100, "Display" to 4)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="RoverCockpit",
	humanName="Rover Cockpit",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 3),
	mass=374.0,
	pcu=100,
	components=mapOf("InteriorPlate" to 30, "Construction" to 25, "Motor" to 2, "Computer" to 20, "Display" to 4)
), BlockData(
	typeId="Gyro",
	xsiType="Gyro",
	subtypeId="LargeBlockGyro",
	humanName="Gyroscope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=12817.0,
	pcu=50,
	components=mapOf("SteelPlate" to 600, "Construction" to 40, "LargeTube" to 4, "MetalGrid" to 50, "Motor" to 4, "Computer" to 5)
), BlockData(
	typeId="Gyro",
	xsiType="Gyro",
	subtypeId="SmallBlockGyro",
	humanName="Gyroscope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=613.6,
	pcu=50,
	components=mapOf("SteelPlate" to 25, "Construction" to 5, "LargeTube" to 1, "Motor" to 2, "Computer" to 3)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="OpenCockpitSmall",
	humanName="Control Seat",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=263.0,
	pcu=50,
	components=mapOf("InteriorPlate" to 20, "Construction" to 20, "Motor" to 1, "Computer" to 15, "Display" to 2)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="OpenCockpitLarge",
	humanName="Control Seat",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=446.0,
	pcu=150,
	components=mapOf("InteriorPlate" to 30, "Construction" to 30, "Motor" to 2, "Computer" to 100, "Display" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorBlock",
	humanName="Light Armor Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=500.0,
	pcu=1,
	components=mapOf("SteelPlate" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlope",
	humanName="Light Armor Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=260.0,
	pcu=1,
	components=mapOf("SteelPlate" to 13)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorCorner",
	humanName="Light Armor Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorCornerInv",
	humanName="Light Armor Inv. Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=420.0,
	pcu=1,
	components=mapOf("SteelPlate" to 21)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeRoundArmor_Slope",
	humanName="Round Armor Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=260.0,
	pcu=1,
	components=mapOf("SteelPlate" to 13)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeRoundArmor_Corner",
	humanName="Round Armor Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeRoundArmor_CornerInv",
	humanName="LargeRoundArmor_CornerInv",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=420.0,
	pcu=1,
	components=mapOf("SteelPlate" to 21)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorBlock",
	humanName="Heavy Armor Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=3300.0,
	pcu=1,
	components=mapOf("SteelPlate" to 150, "MetalGrid" to 50)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorSlope",
	humanName="Heavy Armor Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1650.0,
	pcu=1,
	components=mapOf("SteelPlate" to 75, "MetalGrid" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorCorner",
	humanName="Heavy Armor Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=560.0,
	pcu=1,
	components=mapOf("SteelPlate" to 25, "MetalGrid" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorCornerInv",
	humanName="Heavy Armor Inv. Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2800.0,
	pcu=1,
	components=mapOf("SteelPlate" to 125, "MetalGrid" to 50)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorBlock",
	humanName="Light Armor Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlope",
	humanName="Light Armor Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorCorner",
	humanName="Light Armor Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorCornerInv",
	humanName="Light Armor Inv. Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorBlock",
	humanName="Heavy Armor Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=112.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5, "MetalGrid" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorSlope",
	humanName="Heavy Armor Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorCorner",
	humanName="Heavy Armor Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorCornerInv",
	humanName="Heavy Armor Inv. Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=86.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHalfArmorBlock",
	humanName="Half Light Armor Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=240.0,
	pcu=1,
	components=mapOf("SteelPlate" to 12)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyHalfArmorBlock",
	humanName="Half Heavy Armor Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1650.0,
	pcu=1,
	components=mapOf("SteelPlate" to 75, "MetalGrid" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHalfSlopeArmorBlock",
	humanName="Half Slope Light Armor Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyHalfSlopeArmorBlock",
	humanName="Half Slope Heavy Armor Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=416.0,
	pcu=1,
	components=mapOf("SteelPlate" to 19, "MetalGrid" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="HalfArmorBlock",
	humanName="Half Light Armor Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="HeavyHalfArmorBlock",
	humanName="Half Heavy Armor Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="HalfSlopeArmorBlock",
	humanName="Half Slope Light Armor Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="HeavyHalfSlopeArmorBlock",
	humanName="Half Slope Heavy Armor Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorRoundSlope",
	humanName="Round Armor Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=260.0,
	pcu=1,
	components=mapOf("SteelPlate" to 13)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorRoundCorner",
	humanName="Round Armor Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=80.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorRoundCornerInv",
	humanName="Round Armor Inv. Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=420.0,
	pcu=1,
	components=mapOf("SteelPlate" to 21)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorRoundSlope",
	humanName="Heavy Armor Round Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2900.0,
	pcu=1,
	components=mapOf("SteelPlate" to 130, "MetalGrid" to 50)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorRoundCorner",
	humanName="Heavy Armor Round Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2740.0,
	pcu=1,
	components=mapOf("SteelPlate" to 125, "MetalGrid" to 40)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorRoundCornerInv",
	humanName="Heavy Armor Round Inv. Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=3100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 140, "MetalGrid" to 50)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorRoundSlope",
	humanName="Round Armor Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorRoundCorner",
	humanName="Round Armor Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorRoundCornerInv",
	humanName="Round Armor Inv. Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorRoundSlope",
	humanName="Heavy Armor Round Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=86.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorRoundCorner",
	humanName="Heavy Armor Round Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=86.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorRoundCornerInv",
	humanName="Heavy Armor Round Inv. Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=106.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlope2Base",
	humanName="Light Armor Slope 2x1x1 Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=380.0,
	pcu=1,
	components=mapOf("SteelPlate" to 19)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlope2Tip",
	humanName="Light Armor Slope 2x1x1 Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=120.0,
	pcu=1,
	components=mapOf("SteelPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorCorner2Base",
	humanName="Light Armor Corner 2x1x1 Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=200.0,
	pcu=1,
	components=mapOf("SteelPlate" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorCorner2Tip",
	humanName="Light Armor Corner 2x1x1 Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorInvCorner2Base",
	humanName="Light Armor Inv. Corner 2x1x1 Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=440.0,
	pcu=1,
	components=mapOf("SteelPlate" to 22)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorInvCorner2Tip",
	humanName="Light Armor Inv. Corner 2x1x1 Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=320.0,
	pcu=1,
	components=mapOf("SteelPlate" to 16)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorSlope2Base",
	humanName="Heavy Armor Slope 2x1x1 Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2480.0,
	pcu=1,
	components=mapOf("SteelPlate" to 112, "MetalGrid" to 40)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorSlope2Tip",
	humanName="Heavy Armor Slope 2x1x1 Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=872.0,
	pcu=1,
	components=mapOf("SteelPlate" to 40, "MetalGrid" to 12)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorCorner2Base",
	humanName="Heavy Armor Corner 2x1x1 Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1190.0,
	pcu=1,
	components=mapOf("SteelPlate" to 55, "MetalGrid" to 15)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorCorner2Tip",
	humanName="Heavy Armor Corner 2x1x1 Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=416.0,
	pcu=1,
	components=mapOf("SteelPlate" to 19, "MetalGrid" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorInvCorner2Base",
	humanName="Heavy Armor Inv. Corner 2x1x1 Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2930.0,
	pcu=1,
	components=mapOf("SteelPlate" to 133, "MetalGrid" to 45)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeHeavyBlockArmorInvCorner2Tip",
	humanName="Heavy Armor Inv. Corner 2x1x1 Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2030.0,
	pcu=1,
	components=mapOf("SteelPlate" to 94, "MetalGrid" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlope2Base",
	humanName="Light Armor Slope 2x1x1 Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlope2Tip",
	humanName="Light Armor Slope 2x1x1 Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorCorner2Base",
	humanName="Light Armor Corner 2x1x1 Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorCorner2Tip",
	humanName="Light Armor Corner 2x1x1 Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorInvCorner2Base",
	humanName="Light Armor Inv. Corner 2x1x1 Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorInvCorner2Tip",
	humanName="Light Armor Inv. Corner 2x1x1 Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorSlope2Base",
	humanName="Heavy Armor Slope 2x1x1 Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=92.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "MetalGrid" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorSlope2Tip",
	humanName="Heavy Armor Slope 2x1x1 Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorCorner2Base",
	humanName="Heavy Armor Corner 2x1x1 Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorCorner2Tip",
	humanName="Heavy Armor Corner 2x1x1 Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorInvCorner2Base",
	humanName="Heavy Armor Inv. Corner 2x1x1 Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=106.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallHeavyBlockArmorInvCorner2Tip",
	humanName="Heavy Armor Inv. Corner 2x1x1 Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=106.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorRaisedSlopedCorner",
	humanName="Light Armor Raised Sloped Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=340.0,
	pcu=1,
	components=mapOf("SteelPlate" to 17)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorRaisedSlopedCorner",
	humanName="Light Armor Raised Sloped Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorRaisedSlopedCorner",
	humanName="Heavy Armor Raised Sloped Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2180.0,
	pcu=1,
	components=mapOf("SteelPlate" to 100, "MetalGrid" to 30)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorRaisedSlopedCorner",
	humanName="Heavy Armor Raised Sloped Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=92.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "MetalGrid" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlopeTransition",
	humanName="Light Armor Slope Transition",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=200.0,
	pcu=1,
	components=mapOf("SteelPlate" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlopeTransition",
	humanName="Light Armor Slope Transition",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSlopeTransition",
	humanName="Heavy Armor Slope Transition",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1308.0,
	pcu=1,
	components=mapOf("SteelPlate" to 60, "MetalGrid" to 18)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSlopeTransition",
	humanName="Heavy Armor Slope Transition",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlopeTransitionBase",
	humanName="Light Armor Slope Transition Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=320.0,
	pcu=1,
	components=mapOf("SteelPlate" to 16)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlopeTransitionBase",
	humanName="Light Armor Slope Transition Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSlopeTransitionBase",
	humanName="Heavy Armor Slope Transition Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2110.0,
	pcu=1,
	components=mapOf("SteelPlate" to 95, "MetalGrid" to 35)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSlopeTransitionBase",
	humanName="Heavy Armor Slope Transition Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=92.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "MetalGrid" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlopeTransitionBaseMirrored",
	humanName="Light Armor Slope Transition Base Mirrored",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=320.0,
	pcu=1,
	components=mapOf("SteelPlate" to 16)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlopeTransitionBaseMirrored",
	humanName="Light Armor Slope Transition Base Mirrored",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSlopeTransitionBaseMirrored",
	humanName="Heavy Armor Slope Transition Base Mirrored",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2110.0,
	pcu=1,
	components=mapOf("SteelPlate" to 95, "MetalGrid" to 35)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSlopeTransitionBaseMirrored",
	humanName="Heavy Armor Slope Transition Base Mirrored",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=92.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "MetalGrid" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlopeTransitionMirrored",
	humanName="Light Armor Slope Transition Mirrored",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=200.0,
	pcu=1,
	components=mapOf("SteelPlate" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlopeTransitionMirrored",
	humanName="Light Armor Slope Transition Mirrored",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSlopeTransitionMirrored",
	humanName="Heavy Armor Slope Transition Mirrored",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1308.0,
	pcu=1,
	components=mapOf("SteelPlate" to 60, "MetalGrid" to 18)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSlopeTransitionMirrored",
	humanName="Heavy Armor Slope Transition Mirrored",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlopeTransitionTip",
	humanName="Light Armor Slope Transition Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlopeTransitionTip",
	humanName="Light Armor Slope Transition Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSlopeTransitionTip",
	humanName="Heavy Armor Slope Transition Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=654.0,
	pcu=1,
	components=mapOf("SteelPlate" to 30, "MetalGrid" to 9)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSlopeTransitionTip",
	humanName="Heavy Armor Slope Transition Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSlopeTransitionTipMirrored",
	humanName="Light Armor Slope Transition Tip Mirrored",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=100.0,
	pcu=1,
	components=mapOf("SteelPlate" to 5)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSlopeTransitionTipMirrored",
	humanName="Light Armor Slope Transition Tip Mirrored",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSlopeTransitionTipMirrored",
	humanName="Heavy Armor Slope Transition Tip Mirrored",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=654.0,
	pcu=1,
	components=mapOf("SteelPlate" to 30, "MetalGrid" to 9)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSlopeTransitionTipMirrored",
	humanName="Heavy Armor Slope Transition Tip Mirrored",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSquareSlopedCornerBase",
	humanName="Light Armor Square Sloped Corner Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=360.0,
	pcu=1,
	components=mapOf("SteelPlate" to 18)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSquareSlopedCornerBase",
	humanName="Light Armor Square Sloped Corner Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSquareSlopedCornerBase",
	humanName="Heavy Armor Square Sloped Corner Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2310.0,
	pcu=1,
	components=mapOf("SteelPlate" to 105, "MetalGrid" to 35)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSquareSlopedCornerBase",
	humanName="Heavy Armor Square Sloped Corner Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=92.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "MetalGrid" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSquareSlopedCornerTip",
	humanName="Light Armor Square Sloped Corner Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=120.0,
	pcu=1,
	components=mapOf("SteelPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSquareSlopedCornerTip",
	humanName="Light Armor Square Sloped Corner Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSquareSlopedCornerTip",
	humanName="Heavy Armor Square Sloped Corner Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=654.0,
	pcu=1,
	components=mapOf("SteelPlate" to 30, "MetalGrid" to 9)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSquareSlopedCornerTip",
	humanName="Heavy Armor Square Sloped Corner Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=46.0,
	pcu=1,
	components=mapOf("SteelPlate" to 2, "MetalGrid" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockArmorSquareSlopedCornerTipInv",
	humanName="Light Armor Square Sloped Corner Tip Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=180.0,
	pcu=1,
	components=mapOf("SteelPlate" to 9)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockArmorSquareSlopedCornerTipInv",
	humanName="Light Armor Square Sloped Corner Tip Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockHeavyArmorSquareSlopedCornerTipInv",
	humanName="Heavy Armor Square Sloped Corner Tip Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1208.0,
	pcu=1,
	components=mapOf("SteelPlate" to 55, "MetalGrid" to 18)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockHeavyArmorSquareSlopedCornerTipInv",
	humanName="Heavy Armor Square Sloped Corner Tip Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=66.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "MetalGrid" to 1)
), BlockData(
	typeId="LandingGear",
	xsiType="LandingGear",
	subtypeId="LargeBlockMagneticPlate",
	humanName="Large Magnetic Plate",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 2, 3),
	mass=9960.0,
	pcu=35,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 450, "Construction" to 60, "Motor" to 20)
), BlockData(
	typeId="LandingGear",
	xsiType="LandingGear",
	subtypeId="SmallBlockMagneticPlate",
	humanName="Large Magnetic Plate",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 2, 3),
	mass=312.0,
	pcu=35,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 6, "Construction" to 15, "Motor" to 3)
), BlockData(
	typeId="CargoContainer",
	xsiType="CargoContainer",
	subtypeId="LargeBlockLargeIndustrialContainer",
	humanName="Large Industrial Cargo Container",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=2593.6,
	pcu=10,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 360, "Construction" to 80, "MetalGrid" to 24, "SmallTube" to 60, "Motor" to 20, "Display" to 1, "Computer" to 8)
), BlockData(
	typeId="ButtonPanel",
	xsiType="ButtonPanel",
	subtypeId="VerticalButtonPanelLarge",
	humanName="Vertical Button Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=96.0,
	pcu=5,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 5, "Construction" to 10, "Computer" to 5)
), BlockData(
	typeId="ButtonPanel",
	xsiType="ButtonPanel",
	subtypeId="VerticalButtonPanelSmall",
	humanName="Vertical Button Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 3, 1),
	mass=96.0,
	pcu=5,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 5, "Construction" to 10, "Computer" to 5)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="LargeBlockConveyorPipeSeamless",
	humanName="Conveyor Pipe",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=394.0,
	pcu=10,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 14, "Construction" to 20, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="LargeBlockConveyorPipeCorner",
	humanName="Conveyor Pipe Curved",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=394.0,
	pcu=10,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 14, "Construction" to 20, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="Conveyor",
	subtypeId="LargeBlockConveyorPipeJunction",
	humanName="Conveyor Pipe Junction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=524.0,
	pcu=10,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "SmallTube" to 20, "Motor" to 6)
), BlockData(
	typeId="Conveyor",
	subtypeId="LargeBlockConveyorPipeIntersection",
	humanName="Conveyor Pipe Cross",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=422.0,
	pcu=10,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 18, "Construction" to 20, "SmallTube" to 16, "Motor" to 6)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="LargeBlockConveyorPipeFlange",
	humanName="Conveyor Pipe Flanged",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=394.0,
	pcu=10,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 14, "Construction" to 20, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="ConveyorConnector",
	subtypeId="LargeBlockConveyorPipeEnd",
	humanName="Conveyor Pipe End",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=394.0,
	pcu=10,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 14, "Construction" to 20, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="Conveyor",
	subtypeId="LargeBlockConveyorPipeT",
	humanName="Conveyor Pipe T Junction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=440.0,
	pcu=10,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 16, "Construction" to 24, "SmallTube" to 14, "Motor" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockConveyorPipeCap",
	humanName="Conveyor Pipe Cap",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=110.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 10, "Construction" to 10)
), BlockData(
	typeId="OxygenTank",
	xsiType="GasTank",
	subtypeId="LargeHydrogenTankIndustrial",
	humanName="Industrial Hydrogen Tank",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=8161.6,
	pcu=25,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 280, "LargeTube" to 80, "SmallTube" to 60, "Computer" to 8, "Construction" to 40)
), BlockData(
	typeId="Assembler",
	xsiType="Assembler",
	subtypeId="LargeAssemblerIndustrial",
	humanName="Industrial Assembler",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 2),
	mass=4092.0,
	pcu=40,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 140, "Construction" to 80, "Motor" to 20, "Display" to 10, "MetalGrid" to 10, "Computer" to 160)
), BlockData(
	typeId="Refinery",
	xsiType="Refinery",
	subtypeId="LargeRefineryIndustrial",
	humanName="Industrial Refinery",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 4, 2),
	mass=25328.0,
	pcu=90,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1200, "Construction" to 40, "LargeTube" to 20, "Motor" to 16, "MetalGrid" to 20, "Computer" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockCylindricalColumn",
	humanName="Cylindrical Column",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=155.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 25, "Construction" to 10)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallBlockCylindricalColumn",
	humanName="Cylindrical Column",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=39.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 5, "Construction" to 3)
), BlockData(
	typeId="ConveyorSorter",
	xsiType="ConveyorSorter",
	subtypeId="LargeBlockConveyorSorterIndustrial",
	humanName="Industrial Conveyor Sorter",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1362.0,
	pcu=25,
	dlc="HeavyIndustry",
	components=mapOf("InteriorPlate" to 50, "Construction" to 120, "SmallTube" to 50, "Computer" to 20, "Motor" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeGridBeamBlock",
	humanName="Beam Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=500.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeGridBeamBlockSlope",
	humanName="Beam Block Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=260.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 13)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeGridBeamBlockRound",
	humanName="Beam Block Round",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=260.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 13)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeGridBeamBlockSlope2x1Base",
	humanName="Beam Block2x1 Base",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=380.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 19)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeGridBeamBlockSlope2x1Tip",
	humanName="Beam Block2x1 Tip",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=140.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 7)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeGridBeamBlockHalf",
	humanName="Beam Block Half",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=240.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 12)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeGridBeamBlockHalfSlope",
	humanName="Beam Block Half Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=140.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 7)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeGridBeamBlockEnd",
	humanName="Beam Block End",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=500.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeGridBeamBlockJunction",
	humanName="Beam Block Junction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=500.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeGridBeamBlockTJunction",
	humanName="Beam Block T-Junction",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=500.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallGridBeamBlock",
	humanName="Beam Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallGridBeamBlockSlope",
	humanName="Beam Block Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallGridBeamBlockRound",
	humanName="Beam Block Round",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallGridBeamBlockSlope2x1Base",
	humanName="Beam Block2x1 Base",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallGridBeamBlockSlope2x1Tip",
	humanName="Beam Block2x1 Tip",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallGridBeamBlockHalf",
	humanName="Beam Block Half",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallGridBeamBlockHalfSlope",
	humanName="Beam Block Half Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallGridBeamBlockEnd",
	humanName="Beam Block End",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallGridBeamBlockJunction",
	humanName="Beam Block Junction",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallGridBeamBlockTJunction",
	humanName="Beam Block T-Junction",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=20.0,
	pcu=1,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 1)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockLargeHydrogenThrustIndustrial",
	humanName="Industrial Large Hydrogen Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 4),
	mass=6940.0,
	pcu=15,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 150, "Construction" to 180, "MetalGrid" to 250, "LargeTube" to 40)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockSmallHydrogenThrustIndustrial",
	humanName="Industrial Hydrogen Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1420.0,
	pcu=15,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 25, "Construction" to 60, "MetalGrid" to 40, "LargeTube" to 8)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockLargeHydrogenThrustIndustrial",
	humanName="Industrial Large Hydrogen Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 4),
	mass=1222.0,
	pcu=15,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 30, "Construction" to 30, "MetalGrid" to 22, "LargeTube" to 10)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockSmallHydrogenThrustIndustrial",
	humanName="Industrial Hydrogen Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=334.0,
	pcu=15,
	dlc="HeavyIndustry",
	components=mapOf("SteelPlate" to 7, "Construction" to 15, "MetalGrid" to 4, "LargeTube" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWindowSquare",
	humanName="Vertical Window",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=116.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 12, "Construction" to 8, "SmallTube" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWindowEdge",
	humanName="Diagonal Window",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=168.0,
	pcu=1,
	components=mapOf("InteriorPlate" to 16, "Construction" to 12, "SmallTube" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x2Slope",
	humanName="Window 1x2 Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=921.0,
	pcu=1,
	components=mapOf("Girder" to 16, "BulletproofGlass" to 55)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x2Inv",
	humanName="Window 1x2 Face Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=690.0,
	pcu=1,
	components=mapOf("Girder" to 15, "BulletproofGlass" to 40)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x2Face",
	humanName="Window 1x2 Face",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=690.0,
	pcu=1,
	components=mapOf("Girder" to 15, "BulletproofGlass" to 40)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x2SideLeft",
	humanName="Window 1x2 Side Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=468.0,
	pcu=1,
	components=mapOf("Girder" to 13, "BulletproofGlass" to 26)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x2SideLeftInv",
	humanName="Window 1x2 Side Left Inv",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=468.0,
	pcu=1,
	components=mapOf("Girder" to 13, "BulletproofGlass" to 26)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x2SideRight",
	humanName="Window 1x2 Side Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=468.0,
	pcu=1,
	components=mapOf("Girder" to 13, "BulletproofGlass" to 26)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x2SideRightInv",
	humanName="Window 1x2 Side Right Inv",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=468.0,
	pcu=1,
	components=mapOf("Girder" to 13, "BulletproofGlass" to 26)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x1Slope",
	humanName="Window 1x1 Slope",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=597.0,
	pcu=1,
	components=mapOf("Girder" to 12, "BulletproofGlass" to 35)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x1Face",
	humanName="Window 1x1 Face",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=426.0,
	pcu=1,
	components=mapOf("Girder" to 11, "BulletproofGlass" to 24)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x1Side",
	humanName="Window 1x1 Side",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=309.0,
	pcu=1,
	components=mapOf("Girder" to 9, "BulletproofGlass" to 17)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x1SideInv",
	humanName="Window 1x1 Side Inv",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=309.0,
	pcu=1,
	components=mapOf("Girder" to 9, "BulletproofGlass" to 17)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x1Inv",
	humanName="Window 1x1 Face Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=426.0,
	pcu=1,
	components=mapOf("Girder" to 11, "BulletproofGlass" to 24)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x2Flat",
	humanName="Window 1x2 Flat",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=840.0,
	pcu=1,
	components=mapOf("Girder" to 15, "BulletproofGlass" to 50)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x2FlatInv",
	humanName="Window 1x2 Flat Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=840.0,
	pcu=1,
	components=mapOf("Girder" to 15, "BulletproofGlass" to 50)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x1Flat",
	humanName="Window 1x1 Flat",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=435.0,
	pcu=1,
	components=mapOf("Girder" to 10, "BulletproofGlass" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window1x1FlatInv",
	humanName="Window 1x1 Flat Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=435.0,
	pcu=1,
	components=mapOf("Girder" to 10, "BulletproofGlass" to 25)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window3x3Flat",
	humanName="Window 3x3 Flat",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 3, 3),
	mass=3180.0,
	pcu=1,
	components=mapOf("Girder" to 40, "BulletproofGlass" to 196)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window3x3FlatInv",
	humanName="Window 3x3 Flat Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 3, 3),
	mass=3180.0,
	pcu=1,
	components=mapOf("Girder" to 40, "BulletproofGlass" to 196)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window2x3Flat",
	humanName="Window 2x3 Flat",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 3),
	mass=2250.0,
	pcu=1,
	components=mapOf("Girder" to 25, "BulletproofGlass" to 140)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Window2x3FlatInv",
	humanName="Window 2x3 Flat Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 3),
	mass=2250.0,
	pcu=1,
	components=mapOf("Girder" to 25, "BulletproofGlass" to 140)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x2Slope",
	humanName="Window 1x2 Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=51.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x2Inv",
	humanName="Window 1x2 Face Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=51.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x2Face",
	humanName="Window 1x2 Face",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=51.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x2SideLeft",
	humanName="Window 1x2 Side Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=51.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x2SideLeftInv",
	humanName="Window 1x2 Side Left Inv",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=51.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x2SideRight",
	humanName="Window 1x2 Side Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=51.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x2SideRightInv",
	humanName="Window 1x2 Side Right Inv",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=51.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x1Slope",
	humanName="Window 1x1 Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x1Face",
	humanName="Window 1x1 Face",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x1Side",
	humanName="Window 1x1 Side",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x1SideInv",
	humanName="Window 1x1 Side Inv",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x1Inv",
	humanName="Window 1x1 Face Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x2Flat",
	humanName="Window 1x2 Flat",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=51.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x2FlatInv",
	humanName="Window 1x2 Flat Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=51.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 3)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x1Flat",
	humanName="Window 1x1 Flat",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow1x1FlatInv",
	humanName="Window 1x1 Flat Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow3x3Flat",
	humanName="Window 3x3 Flat",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 3, 3),
	mass=198.0,
	pcu=1,
	components=mapOf("Girder" to 3, "BulletproofGlass" to 12)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow3x3FlatInv",
	humanName="Window 3x3 Flat Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 3, 3),
	mass=198.0,
	pcu=1,
	components=mapOf("Girder" to 3, "BulletproofGlass" to 12)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow2x3Flat",
	humanName="Window 2x3 Flat",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 3),
	mass=132.0,
	pcu=1,
	components=mapOf("Girder" to 2, "BulletproofGlass" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindow2x3FlatInv",
	humanName="Window 2x3 Flat Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 3),
	mass=132.0,
	pcu=1,
	components=mapOf("Girder" to 2, "BulletproofGlass" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowRound",
	humanName="Round Window",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=765.0,
	pcu=1,
	components=mapOf("Girder" to 15, "BulletproofGlass" to 45)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowRoundInv",
	humanName="Round Window Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=765.0,
	pcu=1,
	components=mapOf("Girder" to 15, "BulletproofGlass" to 45)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowRoundCorner",
	humanName="Round Window Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=573.0,
	pcu=1,
	components=mapOf("Girder" to 13, "BulletproofGlass" to 33)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowRoundCornerInv",
	humanName="Round Window Corner Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=573.0,
	pcu=1,
	components=mapOf("Girder" to 13, "BulletproofGlass" to 33)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowRoundFace",
	humanName="Round Window Face",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=369.0,
	pcu=1,
	components=mapOf("Girder" to 9, "BulletproofGlass" to 21)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowRoundFaceInv",
	humanName="Round Window Face Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=369.0,
	pcu=1,
	components=mapOf("Girder" to 9, "BulletproofGlass" to 21)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowRoundInwardsCorner",
	humanName="Round Window Inwards Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=378.0,
	pcu=1,
	components=mapOf("Girder" to 13, "BulletproofGlass" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="WindowRoundInwardsCornerInv",
	humanName="Round Window Inwards Corner Inv.",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=378.0,
	pcu=1,
	components=mapOf("Girder" to 13, "BulletproofGlass" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindowRound",
	humanName="Round Window",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindowRoundInv",
	humanName="Round Window Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindowRoundCorner",
	humanName="Round Window Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindowRoundCornerInv",
	humanName="Round Window Corner Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindowRoundFace",
	humanName="Round Window Face",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindowRoundFaceInv",
	humanName="Round Window Face Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindowRoundInwardsCorner",
	humanName="Round Window Inwards Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWindowRoundInwardsCornerInv",
	humanName="Round Window Inwards Corner Inv.",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=36.0,
	pcu=1,
	components=mapOf("Girder" to 1, "BulletproofGlass" to 2)
), BlockData(
	typeId="PistonBase",
	xsiType="PistonBase",
	subtypeId="LargePistonBase",
	humanName="Piston",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=576.4,
	pcu=100,
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 4, "Motor" to 4, "Computer" to 2)
), BlockData(
	typeId="ExtendedPistonBase",
	xsiType="ExtendedPistonBase",
	subtypeId="LargePistonBase",
	humanName="Piston",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 3, 1),
	mass=576.4,
	pcu=100,
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 4, "Motor" to 4, "Computer" to 2)
), BlockData(
	typeId="PistonTop",
	subtypeId="LargePistonTop",
	humanName="Top Piston Part",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=400.0,
	pcu=1,
	components=mapOf("SteelPlate" to 10, "LargeTube" to 8)
), BlockData(
	typeId="PistonBase",
	xsiType="PistonBase",
	subtypeId="SmallPistonBase",
	humanName="Piston",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=176.2,
	pcu=100,
	components=mapOf("SteelPlate" to 4, "Construction" to 4, "SmallTube" to 4, "Motor" to 2, "Computer" to 1)
), BlockData(
	typeId="ExtendedPistonBase",
	xsiType="ExtendedPistonBase",
	subtypeId="SmallPistonBase",
	humanName="Piston",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 3, 1),
	mass=176.2,
	pcu=100,
	components=mapOf("SteelPlate" to 4, "Construction" to 4, "SmallTube" to 4, "Motor" to 2, "Computer" to 1)
), BlockData(
	typeId="PistonTop",
	subtypeId="SmallPistonTop",
	humanName="Top Piston Part",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=130.0,
	pcu=1,
	components=mapOf("SteelPlate" to 4, "LargeTube" to 2)
), BlockData(
	typeId="MotorStator",
	xsiType="MotorStator",
	subtypeId="LargeStator",
	humanName="Rotor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=576.4,
	pcu=100,
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 4, "Motor" to 4, "Computer" to 2)
), BlockData(
	typeId="MotorRotor",
	subtypeId="LargeRotor",
	humanName="Rotor Part",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=750.0,
	pcu=1,
	components=mapOf("SteelPlate" to 30, "LargeTube" to 6)
), BlockData(
	typeId="MotorStator",
	xsiType="MotorStator",
	subtypeId="SmallStator",
	humanName="Rotor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=168.2,
	pcu=100,
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 1, "Motor" to 1, "Computer" to 1)
), BlockData(
	typeId="MotorRotor",
	subtypeId="SmallRotor",
	humanName="Rotor Part",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=264.0,
	pcu=1,
	components=mapOf("SteelPlate" to 12, "SmallTube" to 6)
), BlockData(
	typeId="MotorAdvancedStator",
	xsiType="MotorAdvancedStator",
	subtypeId="LargeAdvancedStator",
	humanName="Advanced Rotor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=576.4,
	pcu=100,
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 4, "Motor" to 4, "Computer" to 2)
), BlockData(
	typeId="MotorAdvancedRotor",
	subtypeId="LargeAdvancedRotor",
	humanName="Advanced Rotor Part",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=850.0,
	pcu=1,
	components=mapOf("SteelPlate" to 30, "LargeTube" to 10)
), BlockData(
	typeId="MotorAdvancedStator",
	xsiType="MotorStator",
	subtypeId="SmallAdvancedStator",
	humanName="Advanced Rotor 3x3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 2, 3),
	mass=300.4,
	pcu=100,
	components=mapOf("SteelPlate" to 10, "Construction" to 6, "SmallTube" to 1, "Motor" to 2, "Computer" to 2)
), BlockData(
	typeId="MotorAdvancedRotor",
	subtypeId="SmallAdvancedRotor",
	humanName="Advanced Rotor Part 3x3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 2, 3),
	mass=550.0,
	pcu=1,
	components=mapOf("SteelPlate" to 20, "LargeTube" to 6)
), BlockData(
	typeId="MotorAdvancedStator",
	xsiType="MotorStator",
	subtypeId="SmallAdvancedStatorSmall",
	humanName="Advanced Rotor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=168.2,
	pcu=100,
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 1, "Motor" to 1, "Computer" to 1)
), BlockData(
	typeId="MotorAdvancedRotor",
	subtypeId="SmallAdvancedRotorSmall",
	humanName="Advanced Rotor Part",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=264.0,
	pcu=1,
	components=mapOf("SteelPlate" to 12, "SmallTube" to 6)
), BlockData(
	typeId="MotorAdvancedStator",
	xsiType="MotorAdvancedStator",
	subtypeId="LargeHinge",
	humanName="Hinge",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=596.4,
	pcu=100,
	components=mapOf("SteelPlate" to 16, "Construction" to 10, "LargeTube" to 4, "Motor" to 4, "Computer" to 2)
), BlockData(
	typeId="MotorAdvancedRotor",
	subtypeId="LargeHingeHead",
	humanName="Hinge Part",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=404.0,
	pcu=1,
	components=mapOf("SteelPlate" to 12, "LargeTube" to 4, "Construction" to 8)
), BlockData(
	typeId="MotorAdvancedStator",
	xsiType="MotorAdvancedStator",
	subtypeId="MediumHinge",
	humanName="Hinge 3x3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=346.4,
	pcu=100,
	components=mapOf("SteelPlate" to 10, "Construction" to 6, "LargeTube" to 2, "Motor" to 2, "Computer" to 2)
), BlockData(
	typeId="MotorAdvancedRotor",
	subtypeId="MediumHingeHead",
	humanName="Hinge Part 3x3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=202.0,
	pcu=1,
	components=mapOf("SteelPlate" to 6, "LargeTube" to 2, "Construction" to 4)
), BlockData(
	typeId="MotorAdvancedStator",
	xsiType="MotorAdvancedStator",
	subtypeId="SmallHinge",
	humanName="Hinge",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=225.4,
	pcu=100,
	components=mapOf("SteelPlate" to 6, "Construction" to 4, "LargeTube" to 1, "Motor" to 2, "Computer" to 2)
), BlockData(
	typeId="MotorAdvancedRotor",
	subtypeId="SmallHingeHead",
	humanName="Hinge Part",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=101.0,
	pcu=1,
	components=mapOf("SteelPlate" to 3, "LargeTube" to 1, "Construction" to 2)
), BlockData(
	typeId="Refinery",
	xsiType="Refinery",
	subtypeId="LargeRefinery",
	humanName="Refinery",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 4, 2),
	mass=25328.0,
	pcu=90,
	components=mapOf("SteelPlate" to 1200, "Construction" to 40, "LargeTube" to 20, "Motor" to 16, "MetalGrid" to 20, "Computer" to 20)
), BlockData(
	typeId="Refinery",
	xsiType="Refinery",
	subtypeId="Blast Furnace",
	humanName="Basic Refinery",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=2802.0,
	pcu=75,
	components=mapOf("SteelPlate" to 120, "Construction" to 20, "Motor" to 10, "Computer" to 10)
), BlockData(
	typeId="OxygenGenerator",
	xsiType="OxygenGenerator",
	subtypeId="",
	humanName="O2/H2 Generator",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=2587.0,
	pcu=50,
	components=mapOf("SteelPlate" to 120, "Construction" to 5, "LargeTube" to 2, "Motor" to 4, "Computer" to 5)
), BlockData(
	typeId="OxygenGenerator",
	xsiType="OxygenGenerator",
	subtypeId="OxygenGeneratorSmall",
	humanName="O2/H2 Generator",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 2),
	mass=298.6,
	pcu=50,
	components=mapOf("SteelPlate" to 8, "Construction" to 8, "LargeTube" to 2, "Motor" to 1, "Computer" to 3)
), BlockData(
	typeId="Assembler",
	xsiType="Assembler",
	subtypeId="LargeAssembler",
	humanName="Assembler",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=4092.0,
	pcu=40,
	components=mapOf("SteelPlate" to 140, "Construction" to 80, "Motor" to 20, "Display" to 10, "MetalGrid" to 10, "Computer" to 160)
), BlockData(
	typeId="Assembler",
	xsiType="Assembler",
	subtypeId="BasicAssembler",
	humanName="Basic Assembler",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2208.0,
	pcu=40,
	components=mapOf("SteelPlate" to 80, "Construction" to 40, "Motor" to 10, "Display" to 4, "Computer" to 80)
), BlockData(
	typeId="SurvivalKit",
	xsiType="SurvivalKit",
	subtypeId="SurvivalKitLarge",
	humanName="Survival Kit",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1171.0,
	pcu=140,
	components=mapOf("SteelPlate" to 30, "Construction" to 2, "Medical" to 3, "Motor" to 4, "Display" to 1, "Computer" to 5)
), BlockData(
	typeId="SurvivalKit",
	xsiType="SurvivalKit",
	subtypeId="SurvivalKit",
	humanName="Survival Kit",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(4, 3, 3),
	mass=691.0,
	pcu=140,
	components=mapOf("SteelPlate" to 6, "Construction" to 2, "Medical" to 3, "Motor" to 4, "Display" to 1, "Computer" to 5)
), BlockData(
	typeId="OxygenFarm",
	xsiType="OxygenFarm",
	subtypeId="LargeBlockOxygenFarm",
	humanName="Oxygen Farm",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 1, 1),
	mass=3004.0,
	pcu=25,
	components=mapOf("SteelPlate" to 40, "BulletproofGlass" to 100, "LargeTube" to 20, "SmallTube" to 10, "Construction" to 20, "Computer" to 20)
), BlockData(
	typeId="UpgradeModule",
	xsiType="UpgradeModule",
	subtypeId="LargeProductivityModule",
	humanName="Speed Module",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=2508.0,
	pcu=1,
	components=mapOf("SteelPlate" to 100, "Construction" to 40, "SmallTube" to 20, "Computer" to 60, "Motor" to 4)
), BlockData(
	typeId="UpgradeModule",
	xsiType="UpgradeModule",
	subtypeId="LargeEffectivenessModule",
	humanName="Yield Module",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=2856.0,
	pcu=1,
	components=mapOf("SteelPlate" to 100, "Construction" to 50, "SmallTube" to 15, "Superconductor" to 20, "Motor" to 4)
), BlockData(
	typeId="UpgradeModule",
	xsiType="UpgradeModule",
	subtypeId="LargeEnergyModule",
	humanName="Power Efficiency Module",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=2996.0,
	pcu=1,
	components=mapOf("SteelPlate" to 100, "Construction" to 40, "SmallTube" to 20, "PowerCell" to 20, "Motor" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Monolith",
	humanName="Monolith",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 4, 1),
	mass=4550.0,
	pcu=1,
	components=mapOf("SteelPlate" to 130, "Superconductor" to 130)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Stereolith",
	humanName="Stereolith",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 4, 1),
	mass=4550.0,
	pcu=1,
	components=mapOf("SteelPlate" to 130, "Superconductor" to 130)
), BlockData(
	typeId="CubeBlock",
	subtypeId="EngineerPlushie",
	humanName="Engineer Plushie",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=1.0,
	pcu=1,
	components=mapOf("EngineerPlushie" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SabiroidPlushie",
	humanName="Saberoid Plushie",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=1.0,
	pcu=1,
	components=mapOf("SabiroidPlushie" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSignEaster2",
	humanName="Warning Sign Memetic Badger 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=50.0,
	pcu=1,
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSignEaster2",
	humanName="Warning Sign Memetic Badger 2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 1),
	mass=50.0,
	pcu=1,
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSignEaster3",
	humanName="Warning Sign Grid AI",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=50.0,
	pcu=1,
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSignEaster3",
	humanName="Warning Sign Grid AI",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 1),
	mass=50.0,
	pcu=1,
	components=mapOf("Construction" to 4, "InteriorPlate" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSignEaster9",
	humanName="Warning Sign Arrow",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=44.0,
	pcu=1,
	components=mapOf("Construction" to 4, "InteriorPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSignEaster9",
	humanName="Warning Sign Arrow",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=1,
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSignEaster10",
	humanName="Warning Sign AI Powered",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=44.0,
	pcu=1,
	components=mapOf("Construction" to 4, "InteriorPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSignEaster10",
	humanName="Warning Sign AI Powered",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=1,
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSignEaster11",
	humanName="Warning Sign GoodAI",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=44.0,
	pcu=1,
	components=mapOf("Construction" to 4, "InteriorPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSignEaster11",
	humanName="Warning Sign GoodAI",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=1,
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeWarningSignEaster13",
	humanName="Warning Sign Memetic Badger 1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=44.0,
	pcu=1,
	components=mapOf("Construction" to 4, "InteriorPlate" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="SmallWarningSignEaster13",
	humanName="Warning Sign Memetic Badger 1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=19.0,
	pcu=1,
	components=mapOf("Construction" to 2, "InteriorPlate" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockStatueEngineer",
	humanName="Anniversary Statue",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=1620.0,
	pcu=1,
	components=mapOf("Girder" to 30, "SteelPlate" to 60, "Construction" to 30)
), BlockData(
	typeId="RadioAntenna",
	xsiType="RadioAntenna",
	subtypeId="LargeBlockRadioAntennaDish",
	humanName="Antenna Dish",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 3, 5),
	mass=2961.6,
	pcu=100,
	dlc="Frostbite",
	components=mapOf("Construction" to 40, "Girder" to 120, "SteelPlate" to 80, "Computer" to 8, "RadioCommunication" to 40)
), BlockData(
	typeId="Door",
	xsiType="Door",
	subtypeId="LargeBlockGate",
	humanName="Gate",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 2, 1),
	mass=17682.0,
	pcu=115,
	dlc="Frostbite",
	components=mapOf("SteelPlate" to 800, "Construction" to 100, "SmallTube" to 100, "Motor" to 20, "Computer" to 10)
), BlockData(
	typeId="Door",
	xsiType="Door",
	subtypeId="LargeBlockOffsetDoor",
	humanName="Offset Door",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=990.4,
	pcu=115,
	dlc="Frostbite",
	components=mapOf("SteelPlate" to 25, "Construction" to 35, "SmallTube" to 4, "Motor" to 4, "Display" to 1, "Computer" to 2, "BulletproofGlass" to 6)
), BlockData(
	typeId="CubeBlock",
	subtypeId="DeadBody01",
	humanName="Dead Engineer 1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=31.0,
	pcu=10,
	dlc="Frostbite",
	components=mapOf("BulletproofGlass" to 1, "RadioCommunication" to 1, "Display" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="DeadBody02",
	humanName="Dead Engineer 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=31.0,
	pcu=10,
	dlc="Frostbite",
	components=mapOf("BulletproofGlass" to 1, "RadioCommunication" to 1, "Display" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="DeadBody03",
	humanName="Dead Engineer 3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=31.0,
	pcu=10,
	dlc="Frostbite",
	components=mapOf("BulletproofGlass" to 1, "RadioCommunication" to 1, "Display" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="DeadBody04",
	humanName="Dead Engineer 4",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=31.0,
	pcu=10,
	dlc="Frostbite",
	components=mapOf("BulletproofGlass" to 1, "RadioCommunication" to 1, "Display" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="DeadBody05",
	humanName="Dead Engineer 5",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=31.0,
	pcu=10,
	dlc="Frostbite",
	components=mapOf("BulletproofGlass" to 1, "RadioCommunication" to 1, "Display" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="DeadBody06",
	humanName="Dead Engineer 6",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=31.0,
	pcu=10,
	dlc="Frostbite",
	components=mapOf("BulletproofGlass" to 1, "RadioCommunication" to 1, "Display" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeLCDPanel5x5",
	humanName="Sci-Fi LCD Panel 5x5",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 5, 1),
	mass=5530.0,
	pcu=50,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 25, "Construction" to 150, "Computer" to 25, "Display" to 250, "BulletproofGlass" to 150)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeLCDPanel5x3",
	humanName="Sci-Fi LCD Panel 5x3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 3, 1),
	mass=3318.0,
	pcu=50,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 15, "Construction" to 90, "Computer" to 15, "Display" to 150, "BulletproofGlass" to 90)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeLCDPanel3x3",
	humanName="Sci-Fi LCD Panel 3x3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 1),
	mass=1902.0,
	pcu=50,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 10, "Construction" to 50, "Computer" to 10, "Display" to 90, "BulletproofGlass" to 50)
), BlockData(
	typeId="CubeBlock",
	subtypeId="LargeBlockSciFiWall",
	humanName="Sci-Fi Interior Wall",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=155.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 25, "Construction" to 10)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesStraight1",
	humanName="Neon Tubes 1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=58.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 6, "SmallTube" to 6, "Construction" to 2)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesStraight2",
	humanName="Neon Tubes 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=58.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 6, "SmallTube" to 6, "Construction" to 2)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesCorner",
	humanName="Neon Tubes Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=58.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 6, "SmallTube" to 6, "Construction" to 2)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesBendUp",
	humanName="Neon Tubes Up",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=116.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 12, "SmallTube" to 12, "Construction" to 4)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesBendDown",
	humanName="Neon Tubes Down",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=29.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 3, "SmallTube" to 3, "Construction" to 1)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesStraightEnd1",
	humanName="Neon Tubes End 1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=58.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 6, "SmallTube" to 6, "Construction" to 2)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesStraightEnd2",
	humanName="Neon Tubes End 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=86.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 10, "SmallTube" to 6, "Construction" to 4)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesStraightDown",
	humanName="Neon Tubes Down 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=87.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 9, "SmallTube" to 9, "Construction" to 3)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesU",
	humanName="Neon Tubes U Shape",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=174.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 18, "SmallTube" to 18, "Construction" to 6)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesT",
	humanName="Neon Tubes T Shape",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=87.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 9, "SmallTube" to 9, "Construction" to 3)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="LargeNeonTubesCircle",
	humanName="Neon Tubes Circle",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=116.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 12, "SmallTube" to 12, "Construction" to 4)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="SmallNeonTubesStraight1",
	humanName="Neon Tubes 1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=15.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 1, "SmallTube" to 1, "Construction" to 1)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="SmallNeonTubesStraight2",
	humanName="Neon Tubes 2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=15.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 1, "SmallTube" to 1, "Construction" to 1)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="SmallNeonTubesCorner",
	humanName="Neon Tubes Corner",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=15.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 1, "SmallTube" to 1, "Construction" to 1)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="SmallNeonTubesBendUp",
	humanName="Neon Tubes Up",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=15.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 1, "SmallTube" to 1, "Construction" to 1)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="SmallNeonTubesBendDown",
	humanName="Neon Tubes Down",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=15.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 1, "SmallTube" to 1, "Construction" to 1)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="SmallNeonTubesStraightDown",
	humanName="Neon Tubes Down 2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=15.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 1, "SmallTube" to 1, "Construction" to 1)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="SmallNeonTubesStraightEnd1",
	humanName="Neon Tubes End 1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=15.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 1, "SmallTube" to 1, "Construction" to 1)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="SmallNeonTubesU",
	humanName="Neon Tubes U Shape",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=15.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 1, "SmallTube" to 1, "Construction" to 1)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="SmallNeonTubesT",
	humanName="Neon Tubes T Shape",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=15.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 1, "SmallTube" to 1, "Construction" to 1)
), BlockData(
	typeId="EmissiveBlock",
	subtypeId="SmallNeonTubesCircle",
	humanName="Neon Tubes Circle",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=15.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 1, "SmallTube" to 1, "Construction" to 1)
), BlockData(
	typeId="TerminalBlock",
	subtypeId="LargeBlockSciFiTerminal",
	humanName="Sci-Fi Control Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=70.4,
	pcu=5,
	dlc="SparksOfTheFuture",
	components=mapOf("Construction" to 4, "Computer" to 2, "Display" to 4, "InteriorPlate" to 2)
), BlockData(
	typeId="ButtonPanel",
	xsiType="ButtonPanel",
	subtypeId="LargeSciFiButtonTerminal",
	humanName="Sci-Fi One-Button Terminal",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=127.8,
	pcu=50,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 5, "Construction" to 10, "Computer" to 4, "Display" to 4)
), BlockData(
	typeId="Door",
	xsiType="Door",
	subtypeId="SmallSideDoor",
	humanName="Sci-Fi Sliding Door",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 4, 1),
	mass=514.4,
	pcu=115,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 10, "Construction" to 26, "BulletproofGlass" to 4, "Motor" to 2, "Display" to 1, "Computer" to 2, "SteelPlate" to 8)
), BlockData(
	typeId="CubeBlock",
	xsiType="Planter",
	subtypeId="LargeBlockBarCounter",
	humanName="Sci-Fi Bar Counter",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=242.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 16, "Construction" to 10, "Motor" to 1, "BulletproofGlass" to 6)
), BlockData(
	typeId="CubeBlock",
	xsiType="Planter",
	subtypeId="LargeBlockBarCounterCorner",
	humanName="Sci-Fi Bar Counter Corner",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=382.0,
	pcu=1,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 24, "Construction" to 14, "Motor" to 2, "BulletproofGlass" to 10)
), BlockData(
	typeId="ButtonPanel",
	xsiType="ButtonPanel",
	subtypeId="LargeSciFiButtonPanel",
	humanName="Sci-Fi Four-Button Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=234.0,
	pcu=100,
	dlc="SparksOfTheFuture",
	components=mapOf("InteriorPlate" to 10, "Construction" to 20, "Computer" to 20, "Display" to 5)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockSmallThrustSciFi",
	humanName="Sci-Fi Ion Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=121.0,
	pcu=15,
	dlc="SparksOfTheFuture",
	components=mapOf("SteelPlate" to 2, "Construction" to 2, "LargeTube" to 1, "Thrust" to 1)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockLargeThrustSciFi",
	humanName="Sci-Fi Large Ion Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 2, 4),
	mass=721.0,
	pcu=15,
	dlc="SparksOfTheFuture",
	components=mapOf("SteelPlate" to 5, "Construction" to 2, "LargeTube" to 5, "Thrust" to 12)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockSmallThrustSciFi",
	humanName="Sci-Fi Ion Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=4380.0,
	pcu=15,
	dlc="SparksOfTheFuture",
	components=mapOf("SteelPlate" to 25, "Construction" to 60, "LargeTube" to 8, "Thrust" to 80)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockLargeThrustSciFi",
	humanName="Sci-Fi Large Ion Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 2, 4),
	mass=43200.0,
	pcu=15,
	dlc="SparksOfTheFuture",
	components=mapOf("SteelPlate" to 150, "Construction" to 100, "LargeTube" to 40, "Thrust" to 960)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockLargeAtmosphericThrustSciFi",
	humanName="Sci-Fi Large Atmospheric Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 5),
	mass=32970.0,
	pcu=15,
	dlc="SparksOfTheFuture",
	components=mapOf("SteelPlate" to 230, "Construction" to 60, "LargeTube" to 50, "MetalGrid" to 40, "Motor" to 1100)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="LargeBlockSmallAtmosphericThrustSciFi",
	humanName="Sci-Fi Atmospheric Thruster",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 3),
	mass=4000.0,
	pcu=15,
	dlc="SparksOfTheFuture",
	components=mapOf("SteelPlate" to 35, "Construction" to 50, "LargeTube" to 8, "MetalGrid" to 10, "Motor" to 110)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockLargeAtmosphericThrustSciFi",
	humanName="Sci-Fi Large Atmospheric Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 5),
	mass=2948.0,
	pcu=15,
	dlc="SparksOfTheFuture",
	components=mapOf("SteelPlate" to 20, "Construction" to 30, "LargeTube" to 4, "MetalGrid" to 8, "Motor" to 90)
), BlockData(
	typeId="Thrust",
	xsiType="Thrust",
	subtypeId="SmallBlockSmallAtmosphericThrustSciFi",
	humanName="Sci-Fi Atmospheric Thruster",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 3),
	mass=699.0,
	pcu=15,
	dlc="SparksOfTheFuture",
	components=mapOf("SteelPlate" to 3, "Construction" to 22, "LargeTube" to 1, "MetalGrid" to 1, "Motor" to 18)
), BlockData(
	typeId="LandingGear",
	xsiType="LandingGear",
	subtypeId="LargeBlockLandingGear",
	humanName="Landing Gear",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 3),
	mass=3304.0,
	pcu=35,
	components=mapOf("SteelPlate" to 150, "Construction" to 20, "Motor" to 6)
), BlockData(
	typeId="LandingGear",
	xsiType="LandingGear",
	subtypeId="SmallBlockLandingGear",
	humanName="Landing Gear",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 3),
	mass=104.0,
	pcu=35,
	components=mapOf("SteelPlate" to 2, "Construction" to 5, "Motor" to 1)
), BlockData(
	typeId="LandingGear",
	xsiType="LandingGear",
	subtypeId="LargeBlockSmallMagneticPlate",
	humanName="Magnetic Plate",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=348.0,
	pcu=35,
	components=mapOf("SteelPlate" to 15, "Construction" to 3, "Motor" to 1)
), BlockData(
	typeId="LandingGear",
	xsiType="LandingGear",
	subtypeId="SmallBlockSmallMagneticPlate",
	humanName="Magnetic Plate",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=72.0,
	pcu=35,
	components=mapOf("SteelPlate" to 2, "Construction" to 1, "Motor" to 1)
), BlockData(
	typeId="JumpDrive",
	xsiType="JumpDrive",
	subtypeId="LargeJumpDrive",
	humanName="Jump Drive",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 2),
	mass=35980.0,
	pcu=100,
	components=mapOf("SteelPlate" to 60, "MetalGrid" to 50, "GravityGenerator" to 20, "Detector" to 20, "PowerCell" to 120, "Superconductor" to 1000, "Computer" to 300, "Construction" to 40)
), BlockData(
	typeId="CameraBlock",
	xsiType="CameraBlock",
	subtypeId="SmallCameraBlock",
	humanName="Camera",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=40.6,
	pcu=25,
	components=mapOf("SteelPlate" to 2, "Computer" to 3)
), BlockData(
	typeId="CameraBlock",
	xsiType="CameraBlock",
	subtypeId="LargeCameraBlock",
	humanName="Camera",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=40.6,
	pcu=25,
	components=mapOf("SteelPlate" to 2, "Computer" to 3)
), BlockData(
	typeId="MergeBlock",
	xsiType="MergeBlock",
	subtypeId="LargeShipMergeBlock",
	humanName="Merge Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=558.4,
	pcu=125,
	components=mapOf("SteelPlate" to 12, "Construction" to 15, "Motor" to 2, "LargeTube" to 6, "Computer" to 2)
), BlockData(
	typeId="MergeBlock",
	xsiType="MergeBlock",
	subtypeId="SmallShipMergeBlock",
	humanName="Merge Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 3, 3),
	mass=152.2,
	pcu=125,
	components=mapOf("SteelPlate" to 4, "Construction" to 5, "Motor" to 1, "SmallTube" to 2, "Computer" to 1)
), BlockData(
	typeId="MergeBlock",
	xsiType="MergeBlock",
	subtypeId="SmallShipSmallMergeBlock",
	humanName="Small Merge Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=92.2,
	pcu=125,
	components=mapOf("SteelPlate" to 2, "Construction" to 3, "Motor" to 1, "SmallTube" to 1, "Computer" to 1)
), BlockData(
	typeId="Parachute",
	xsiType="Parachute",
	subtypeId="LgParachute",
	humanName="Parachute Hatch",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=472.4,
	pcu=50,
	components=mapOf("SteelPlate" to 9, "Construction" to 25, "SmallTube" to 5, "Motor" to 3, "Computer" to 2)
), BlockData(
	typeId="Parachute",
	xsiType="Parachute",
	subtypeId="SmParachute",
	humanName="Parachute Hatch",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=84.2,
	pcu=50,
	components=mapOf("SteelPlate" to 2, "Construction" to 2, "SmallTube" to 1, "Motor" to 1, "Computer" to 1)
), BlockData(
	typeId="Drill",
	xsiType="ShipDrill",
	subtypeId="SmallBlockDrill",
	humanName="Drill",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 6),
	mass=1004.2,
	pcu=190,
	components=mapOf("SteelPlate" to 32, "Construction" to 30, "LargeTube" to 4, "Motor" to 1, "Computer" to 1)
), BlockData(
	typeId="Drill",
	xsiType="ShipDrill",
	subtypeId="LargeBlockDrill",
	humanName="Drill",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 3),
	mass=6741.0,
	pcu=190,
	components=mapOf("SteelPlate" to 300, "Construction" to 40, "LargeTube" to 12, "Motor" to 5, "Computer" to 5)
), BlockData(
	typeId="ShipGrinder",
	xsiType="ShipGrinder",
	subtypeId="LargeShipGrinder",
	humanName="Grinder",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=761.4,
	pcu=100,
	components=mapOf("SteelPlate" to 20, "Construction" to 30, "LargeTube" to 1, "Motor" to 4, "Computer" to 2)
), BlockData(
	typeId="ShipGrinder",
	xsiType="ShipGrinder",
	subtypeId="SmallShipGrinder",
	humanName="Grinder",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 6),
	mass=488.4,
	pcu=100,
	components=mapOf("SteelPlate" to 12, "Construction" to 17, "SmallTube" to 4, "Motor" to 4, "Computer" to 2)
), BlockData(
	typeId="ShipWelder",
	xsiType="ShipWelder",
	subtypeId="LargeShipWelder",
	humanName="Welder",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=713.4,
	pcu=150,
	components=mapOf("SteelPlate" to 20, "Construction" to 30, "LargeTube" to 1, "Motor" to 2, "Computer" to 2)
), BlockData(
	typeId="ShipWelder",
	xsiType="ShipWelder",
	subtypeId="SmallShipWelder",
	humanName="Welder",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 6),
	mass=448.4,
	pcu=150,
	components=mapOf("SteelPlate" to 12, "Construction" to 17, "SmallTube" to 6, "Motor" to 2, "Computer" to 2)
), BlockData(
	typeId="OreDetector",
	xsiType="OreDetector",
	subtypeId="LargeOreDetector",
	humanName="Ore Detector",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=1545.0,
	pcu=40,
	components=mapOf("SteelPlate" to 50, "Construction" to 40, "Motor" to 5, "Computer" to 25, "Detector" to 20)
), BlockData(
	typeId="OreDetector",
	xsiType="OreDetector",
	subtypeId="SmallBlockOreDetector",
	humanName="Ore Detector",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=105.2,
	pcu=40,
	components=mapOf("SteelPlate" to 3, "Construction" to 2, "Motor" to 1, "Computer" to 1, "Detector" to 1)
), BlockData(
	typeId="GravityGenerator",
	xsiType="GravityGenerator",
	subtypeId="",
	humanName="Gravity Generator",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=8532.0,
	pcu=185,
	components=mapOf("SteelPlate" to 150, "GravityGenerator" to 6, "Construction" to 60, "LargeTube" to 4, "Motor" to 6, "Computer" to 40)
), BlockData(
	typeId="GravityGeneratorSphere",
	xsiType="GravityGeneratorSphere",
	subtypeId="",
	humanName="Spherical Gravity Generator",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=8532.0,
	pcu=200,
	components=mapOf("SteelPlate" to 150, "GravityGenerator" to 6, "Construction" to 60, "LargeTube" to 4, "Motor" to 6, "Computer" to 40)
), BlockData(
	typeId="VirtualMass",
	xsiType="VirtualMass",
	subtypeId="VirtualMassLarge",
	humanName="Artificial Mass",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=9544.0,
	pcu=25,
	components=mapOf("SteelPlate" to 90, "Superconductor" to 20, "Construction" to 30, "Computer" to 20, "GravityGenerator" to 9)
), BlockData(
	typeId="VirtualMass",
	xsiType="VirtualMass",
	subtypeId="VirtualMassSmall",
	humanName="Artificial Mass",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=906.4,
	pcu=25,
	components=mapOf("SteelPlate" to 3, "Superconductor" to 2, "Construction" to 2, "Computer" to 2, "GravityGenerator" to 1)
), BlockData(
	typeId="SpaceBall",
	xsiType="SpaceBall",
	subtypeId="SpaceBallLarge",
	humanName="Space Ball",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=7144.0,
	pcu=25,
	components=mapOf("SteelPlate" to 225, "Construction" to 30, "Computer" to 20, "GravityGenerator" to 3)
), BlockData(
	typeId="SpaceBall",
	xsiType="SpaceBall",
	subtypeId="SpaceBallSmall",
	humanName="Space Ball",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=2281.4,
	pcu=25,
	components=mapOf("SteelPlate" to 70, "Construction" to 10, "Computer" to 7, "GravityGenerator" to 1)
), BlockData(
	typeId="ExhaustBlock",
	xsiType="ExhaustBlock",
	subtypeId="SmallExhaustPipe",
	humanName="Exhaust Pipe",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=104.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 2, "Construction" to 1, "SmallTube" to 2, "Motor" to 2)
), BlockData(
	typeId="ExhaustBlock",
	xsiType="ExhaustBlock",
	subtypeId="LargeExhaustPipe",
	humanName="Exhaust Pipe",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=526.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 2, "Motor" to 4)
), BlockData(
	typeId="Cockpit",
	xsiType="Cockpit",
	subtypeId="BuggyCockpit",
	humanName="Buggy Cockpit",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 3),
	mass=374.0,
	pcu=100,
	dlc="ScrapRace",
	components=mapOf("InteriorPlate" to 30, "Construction" to 25, "Motor" to 2, "Computer" to 20, "Display" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Viewport1",
	humanName="Viewport 1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=400.0,
	pcu=1,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 10, "Construction" to 10, "BulletproofGlass" to 8)
), BlockData(
	typeId="CubeBlock",
	subtypeId="Viewport2",
	humanName="Viewport 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=400.0,
	pcu=1,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 10, "Construction" to 10, "BulletproofGlass" to 8)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSuspension3x3",
	humanName="Offroad Wheel Suspension 3x3 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSuspension5x5",
	humanName="Offroad Wheel Suspension 5x5 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 3, 2),
	mass=2820.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 70, "Construction" to 40, "LargeTube" to 20, "SmallTube" to 30, "Motor" to 20)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSuspension1x1",
	humanName="Offroad Wheel Suspension 1x1 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSuspension2x2",
	humanName="Offroad Wheel Suspension 2x2 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallSuspension3x3",
	humanName="Offroad Wheel Suspension 3x3 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallSuspension5x5",
	humanName="Offroad Wheel Suspension 5x5 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 2),
	mass=480.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 16, "Construction" to 12, "SmallTube" to 4, "Motor" to 2)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallSuspension1x1",
	humanName="Offroad Wheel Suspension 1x1 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallSuspension2x2",
	humanName="Offroad Wheel Suspension 2x2 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSuspension3x3mirrored",
	humanName="Offroad Wheel Suspension 3x3 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSuspension5x5mirrored",
	humanName="Offroad Wheel Suspension 5x5 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 3, 2),
	mass=2820.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 70, "Construction" to 40, "LargeTube" to 20, "SmallTube" to 30, "Motor" to 20)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSuspension1x1mirrored",
	humanName="Offroad Wheel Suspension 1x1 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSuspension2x2Mirrored",
	humanName="Offroad Wheel Suspension 2x2 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=962.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 25, "Construction" to 15, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallSuspension3x3mirrored",
	humanName="Offroad Wheel Suspension 3x3 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallSuspension5x5mirrored",
	humanName="Offroad Wheel Suspension 5x5 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 3, 2),
	mass=480.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 16, "Construction" to 12, "SmallTube" to 4, "Motor" to 2)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallSuspension1x1mirrored",
	humanName="Offroad Wheel Suspension 1x1 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallSuspension2x2Mirrored",
	humanName="Offroad Wheel Suspension 2x2 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 2, 1),
	mass=248.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 7, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallRealWheel1x1",
	humanName="Offroad Wheel 1x1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=105.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 2, "Construction" to 5, "LargeTube" to 1)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallRealWheel2x2",
	humanName="Offroad Wheel 2x2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 1, 2),
	mass=355.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 15, "LargeTube" to 3)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallRealWheel",
	humanName="Offroad Wheel 3x3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 1, 3),
	mass=355.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 15, "LargeTube" to 3)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallRealWheel5x5",
	humanName="Offroad Wheel 5x5",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 3, 5),
	mass=625.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 15, "Construction" to 25, "LargeTube" to 5)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadRealWheel1x1",
	humanName="Offroad Wheel 1x1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1090.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 30, "Construction" to 30, "LargeTube" to 10)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadRealWheel2x2",
	humanName="Offroad Wheel 2x2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 2),
	mass=1695.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 50, "Construction" to 40, "LargeTube" to 15)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadRealWheel",
	humanName="Offroad Wheel 3x3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 2, 3),
	mass=2300.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 70, "Construction" to 50, "LargeTube" to 20)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadRealWheel5x5",
	humanName="Offroad Wheel 5x5",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 3, 5),
	mass=3910.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 130, "Construction" to 70, "LargeTube" to 30)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallRealWheel1x1mirrored",
	humanName="Offroad Wheel 1x1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=105.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 2, "Construction" to 5, "LargeTube" to 1)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallRealWheel2x2Mirrored",
	humanName="Offroad Wheel 2x2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 1, 2),
	mass=355.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 15, "LargeTube" to 3)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallRealWheelmirrored",
	humanName="Offroad Wheel 3x3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 1, 3),
	mass=355.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 15, "LargeTube" to 3)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallRealWheel5x5mirrored",
	humanName="Offroad Wheel 5x5",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 3, 5),
	mass=625.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 15, "Construction" to 25, "LargeTube" to 5)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadRealWheel1x1mirrored",
	humanName="Offroad Wheel 1x1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1090.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 30, "Construction" to 30, "LargeTube" to 10)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadRealWheel2x2Mirrored",
	humanName="Offroad Wheel 2x2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 2),
	mass=1695.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 50, "Construction" to 40, "LargeTube" to 15)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadRealWheelmirrored",
	humanName="Offroad Wheel 3x3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 2, 3),
	mass=2300.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 70, "Construction" to 50, "LargeTube" to 20)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadRealWheel5x5mirrored",
	humanName="Offroad Wheel 5x5",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 3, 5),
	mass=3910.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 130, "Construction" to 70, "LargeTube" to 30)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadWheel1x1",
	humanName="Offroad Wheel 1x1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1090.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 30, "Construction" to 30, "LargeTube" to 10)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallWheel1x1",
	humanName="Offroad Wheel 1x1",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=105.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 2, "Construction" to 5, "LargeTube" to 1)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadWheel3x3",
	humanName="Offroad Wheel 3x3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 1, 3),
	mass=2300.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 70, "Construction" to 50, "LargeTube" to 20)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallWheel3x3",
	humanName="Offroad Wheel 3x3",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 1, 3),
	mass=355.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 8, "Construction" to 15, "LargeTube" to 3)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadWheel5x5",
	humanName="Offroad Wheel 5x5",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(5, 2, 5),
	mass=3910.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 130, "Construction" to 70, "LargeTube" to 30)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallWheel5x5",
	humanName="Offroad Wheel 5x5",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(5, 2, 5),
	mass=625.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 15, "Construction" to 25, "LargeTube" to 5)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadWheel2x2",
	humanName="Offroad Wheel 2x2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 2),
	mass=1695.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 50, "Construction" to 40, "LargeTube" to 15)
), BlockData(
	typeId="Wheel",
	subtypeId="OffroadSmallWheel2x2",
	humanName="Offroad Wheel 2x2",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 1, 2),
	mass=230.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 5, "Construction" to 10, "LargeTube" to 2)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadShortSuspension3x3",
	humanName="Offroad Short Wheel Suspension 3x3 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadShortSuspension5x5",
	humanName="Offroad Short Wheel Suspension 5x5 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 2, 2),
	mass=2240.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 45, "Construction" to 30, "LargeTube" to 20, "SmallTube" to 30, "Motor" to 20)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadShortSuspension1x1",
	humanName="Offroad Short Wheel Suspension 1x1 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadShortSuspension2x2",
	humanName="Offroad Short Wheel Suspension 2x2 Right",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallShortSuspension3x3",
	humanName="Offroad Short Wheel Suspension 3x3 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallShortSuspension5x5",
	humanName="Offroad Short Wheel Suspension 5x5 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 2, 2),
	mass=344.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 10, "Construction" to 10, "SmallTube" to 4, "Motor" to 2)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallShortSuspension1x1",
	humanName="Offroad Short Wheel Suspension 1x1 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallShortSuspension2x2",
	humanName="Offroad Short Wheel Suspension 2x2 Right",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadShortSuspension3x3mirrored",
	humanName="Offroad Short Wheel Suspension 3x3 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadShortSuspension5x5mirrored",
	humanName="Offroad Short Wheel Suspension 5x5 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 2, 2),
	mass=2240.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 45, "Construction" to 30, "LargeTube" to 20, "SmallTube" to 30, "Motor" to 20)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadShortSuspension1x1mirrored",
	humanName="Offroad Short Wheel Suspension 1x1 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadShortSuspension2x2Mirrored",
	humanName="Offroad Short Wheel Suspension 2x2 Left",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=722.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 15, "Construction" to 10, "LargeTube" to 6, "SmallTube" to 12, "Motor" to 6)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallShortSuspension3x3mirrored",
	humanName="Offroad Short Wheel Suspension 3x3 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallShortSuspension5x5mirrored",
	humanName="Offroad Short Wheel Suspension 5x5 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(2, 2, 2),
	mass=344.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 10, "Construction" to 10, "SmallTube" to 4, "Motor" to 2)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallShortSuspension1x1mirrored",
	humanName="Offroad Short Wheel Suspension 1x1 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="MotorSuspension",
	xsiType="MotorSuspension",
	subtypeId="OffroadSmallShortSuspension2x2Mirrored",
	humanName="Offroad Short Wheel Suspension 2x2 Left",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=172.0,
	pcu=50,
	dlc="ScrapRace",
	components=mapOf("SteelPlate" to 5, "Construction" to 5, "SmallTube" to 2, "Motor" to 1)
), BlockData(
	typeId="InteriorLight",
	xsiType="LightingBlock",
	subtypeId="OffsetLight",
	humanName="Offset Light",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=16.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("Construction" to 2)
), BlockData(
	typeId="ReflectorLight",
	xsiType="ReflectorBlock",
	subtypeId="OffsetSpotlight",
	humanName="Offset Spotlight",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=31.0,
	pcu=25,
	dlc="ScrapRace",
	components=mapOf("Construction" to 2, "BulletproofGlass" to 1)
), BlockData(
	typeId="CubeBlock",
	subtypeId="BarredWindow",
	humanName="Barred Window",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=38.0,
	pcu=1,
	dlc="ScrapRace",
	components=mapOf("Girder" to 1, "Construction" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="BarredWindowSlope",
	humanName="Barred Window Slope",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=38.0,
	pcu=1,
	dlc="ScrapRace",
	components=mapOf("Girder" to 1, "Construction" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="BarredWindowSide",
	humanName="Barred Window Side",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=38.0,
	pcu=1,
	dlc="ScrapRace",
	components=mapOf("Girder" to 1, "Construction" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="BarredWindowFace",
	humanName="Barred Window Face",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=38.0,
	pcu=1,
	dlc="ScrapRace",
	components=mapOf("Girder" to 1, "Construction" to 4)
), BlockData(
	typeId="CubeBlock",
	subtypeId="StorageShelf1",
	humanName="Storage Shelf 1",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1810.0,
	pcu=1,
	dlc="ScrapRace",
	components=mapOf("Girder" to 10, "SteelPlate" to 50, "Construction" to 50, "SmallTube" to 50, "InteriorPlate" to 50)
), BlockData(
	typeId="CubeBlock",
	subtypeId="StorageShelf2",
	humanName="Storage Shelf 2",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=1280.0,
	pcu=1,
	dlc="ScrapRace",
	components=mapOf("Girder" to 30, "PowerCell" to 20, "Motor" to 20, "MetalGrid" to 20)
), BlockData(
	typeId="CubeBlock",
	subtypeId="StorageShelf3",
	humanName="Storage Shelf 3",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=2460.0,
	pcu=1,
	dlc="ScrapRace",
	components=mapOf("Girder" to 10, "Reactor" to 10, "Superconductor" to 10, "Thrust" to 10, "GravityGenerator" to 2)
), BlockData(
	typeId="BatteryBlock",
	xsiType="BatteryBlock",
	subtypeId="LargeBlockBatteryBlock",
	humanName="Battery",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=3845.0,
	pcu=15,
	components=mapOf("SteelPlate" to 80, "Construction" to 30, "PowerCell" to 80, "Computer" to 25)
), BlockData(
	typeId="BatteryBlock",
	xsiType="BatteryBlock",
	subtypeId="SmallBlockBatteryBlock",
	humanName="Battery",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 2, 3),
	mass=1040.4,
	pcu=15,
	components=mapOf("SteelPlate" to 25, "Construction" to 5, "PowerCell" to 20, "Computer" to 2)
), BlockData(
	typeId="BatteryBlock",
	xsiType="BatteryBlock",
	subtypeId="SmallBlockSmallBatteryBlock",
	humanName="Small Battery",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=146.4,
	pcu=15,
	components=mapOf("SteelPlate" to 4, "Construction" to 2, "PowerCell" to 2, "Computer" to 2)
), BlockData(
	typeId="Reactor",
	xsiType="Reactor",
	subtypeId="SmallBlockSmallGenerator",
	humanName="Small Reactor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=278.0,
	pcu=25,
	components=mapOf("SteelPlate" to 3, "Construction" to 10, "MetalGrid" to 2, "LargeTube" to 1, "Reactor" to 3, "Motor" to 1, "Computer" to 10)
), BlockData(
	typeId="Reactor",
	xsiType="Reactor",
	subtypeId="SmallBlockLargeGenerator",
	humanName="Large Reactor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=3901.0,
	pcu=25,
	components=mapOf("SteelPlate" to 60, "Construction" to 9, "MetalGrid" to 9, "LargeTube" to 3, "Reactor" to 95, "Motor" to 5, "Computer" to 25)
), BlockData(
	typeId="Reactor",
	xsiType="Reactor",
	subtypeId="LargeBlockSmallGenerator",
	humanName="Small Reactor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=4793.0,
	pcu=25,
	components=mapOf("SteelPlate" to 80, "Construction" to 40, "MetalGrid" to 4, "LargeTube" to 8, "Reactor" to 100, "Motor" to 6, "Computer" to 25)
), BlockData(
	typeId="Reactor",
	xsiType="Reactor",
	subtypeId="LargeBlockLargeGenerator",
	humanName="Large Reactor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=73795.0,
	pcu=25,
	components=mapOf("SteelPlate" to 1000, "Construction" to 70, "MetalGrid" to 40, "LargeTube" to 40, "Superconductor" to 100, "Reactor" to 2000, "Motor" to 20, "Computer" to 75)
), BlockData(
	typeId="HydrogenEngine",
	xsiType="HydrogenEngine",
	subtypeId="LargeHydrogenEngine",
	humanName="Hydrogen Engine",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 2),
	mass=3253.8,
	pcu=25,
	components=mapOf("SteelPlate" to 100, "Construction" to 70, "LargeTube" to 12, "SmallTube" to 20, "Motor" to 12, "Computer" to 4, "PowerCell" to 1)
), BlockData(
	typeId="HydrogenEngine",
	xsiType="HydrogenEngine",
	subtypeId="SmallHydrogenEngine",
	humanName="Hydrogen Engine",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 2, 2),
	mass=1005.2,
	pcu=25,
	components=mapOf("SteelPlate" to 30, "Construction" to 20, "LargeTube" to 4, "SmallTube" to 6, "Motor" to 4, "Computer" to 1, "PowerCell" to 1)
), BlockData(
	typeId="WindTurbine",
	xsiType="WindTurbine",
	subtypeId="LargeBlockWindTurbine",
	humanName="Wind Turbine",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(3, 3, 3),
	mass=616.4,
	pcu=55,
	components=mapOf("InteriorPlate" to 40, "Motor" to 8, "Construction" to 20, "Girder" to 24, "Computer" to 2)
), BlockData(
	typeId="SolarPanel",
	xsiType="SolarPanel",
	subtypeId="LargeBlockSolarPanel",
	humanName="Solar Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(4, 2, 1),
	mass=516.8,
	pcu=55,
	components=mapOf("SteelPlate" to 4, "Construction" to 14, "Girder" to 12, "Computer" to 4, "SolarCell" to 32, "BulletproofGlass" to 4)
), BlockData(
	typeId="SolarPanel",
	xsiType="SolarPanel",
	subtypeId="SmallBlockSolarPanel",
	humanName="Solar Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(10, 5, 1),
	mass=143.2,
	pcu=55,
	components=mapOf("SteelPlate" to 2, "Construction" to 2, "Girder" to 4, "Computer" to 1, "SolarCell" to 8, "BulletproofGlass" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="SmallTextPanel",
	humanName="Text Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=74.8,
	pcu=50,
	components=mapOf("InteriorPlate" to 1, "Construction" to 4, "Computer" to 4, "Display" to 3, "BulletproofGlass" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="SmallLCDPanelWide",
	humanName="Wide LCD Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(6, 3, 1),
	mass=146.6,
	pcu=50,
	components=mapOf("InteriorPlate" to 1, "Construction" to 8, "Computer" to 8, "Display" to 6, "BulletproofGlass" to 2)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="SmallLCDPanel",
	humanName="LCD Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 1),
	mass=89.8,
	pcu=50,
	components=mapOf("InteriorPlate" to 1, "Construction" to 4, "Computer" to 4, "Display" to 3, "BulletproofGlass" to 2)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeBlockCorner_LCD_1",
	humanName="Corner LCD Top",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=48.6,
	pcu=50,
	components=mapOf("Construction" to 5, "Computer" to 3, "Display" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeBlockCorner_LCD_2",
	humanName="Corner LCD Bottom",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=48.6,
	pcu=50,
	components=mapOf("Construction" to 5, "Computer" to 3, "Display" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeBlockCorner_LCD_Flat_1",
	humanName="Corner LCD Flat Top",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=48.6,
	pcu=50,
	components=mapOf("Construction" to 5, "Computer" to 3, "Display" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeBlockCorner_LCD_Flat_2",
	humanName="Corner LCD Flat Bottom",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=48.6,
	pcu=50,
	components=mapOf("Construction" to 5, "Computer" to 3, "Display" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="SmallBlockCorner_LCD_1",
	humanName="Corner LCD Top",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=32.4,
	pcu=50,
	components=mapOf("Construction" to 3, "Computer" to 2, "Display" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="SmallBlockCorner_LCD_2",
	humanName="Corner LCD Bottom",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=32.4,
	pcu=50,
	components=mapOf("Construction" to 3, "Computer" to 2, "Display" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="SmallBlockCorner_LCD_Flat_1",
	humanName="Corner LCD Flat Top",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=32.4,
	pcu=50,
	components=mapOf("Construction" to 3, "Computer" to 2, "Display" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="SmallBlockCorner_LCD_Flat_2",
	humanName="Corner LCD Flat Bottom",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=32.4,
	pcu=50,
	components=mapOf("Construction" to 3, "Computer" to 2, "Display" to 1)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeTextPanel",
	humanName="Text Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=162.2,
	pcu=50,
	components=mapOf("InteriorPlate" to 1, "Construction" to 6, "Computer" to 6, "Display" to 10, "BulletproofGlass" to 2)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeLCDPanel",
	humanName="LCD Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=222.2,
	pcu=50,
	components=mapOf("InteriorPlate" to 1, "Construction" to 6, "Computer" to 6, "Display" to 10, "BulletproofGlass" to 6)
), BlockData(
	typeId="TextPanel",
	xsiType="TextPanel",
	subtypeId="LargeLCDPanelWide",
	humanName="Wide LCD Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(2, 1, 1),
	mass=444.4,
	pcu=50,
	components=mapOf("InteriorPlate" to 2, "Construction" to 12, "Computer" to 12, "Display" to 20, "BulletproofGlass" to 12)
), BlockData(
	typeId="MyProgrammableBlock",
	xsiType="ProgrammableBlock",
	subtypeId="SmallProgrammableBlock",
	humanName="Programmable Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=138.4,
	pcu=100,
	components=mapOf("SteelPlate" to 2, "Construction" to 2, "LargeTube" to 2, "Motor" to 1, "Display" to 1, "Computer" to 2)
), BlockData(
	typeId="Projector",
	xsiType="Projector",
	subtypeId="LargeProjector",
	humanName="Projector",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=526.4,
	pcu=50,
	components=mapOf("SteelPlate" to 21, "Construction" to 4, "LargeTube" to 2, "Motor" to 1, "Computer" to 2)
), BlockData(
	typeId="Projector",
	xsiType="Projector",
	subtypeId="SmallProjector",
	humanName="Projector",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=130.4,
	pcu=50,
	components=mapOf("SteelPlate" to 2, "Construction" to 2, "LargeTube" to 2, "Motor" to 1, "Computer" to 2)
), BlockData(
	typeId="SensorBlock",
	xsiType="SensorBlock",
	subtypeId="SmallBlockSensor",
	humanName="Sensor",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=158.2,
	pcu=25,
	components=mapOf("InteriorPlate" to 5, "Construction" to 5, "Computer" to 6, "RadioCommunication" to 4, "Detector" to 6, "SteelPlate" to 2)
), BlockData(
	typeId="SensorBlock",
	xsiType="SensorBlock",
	subtypeId="LargeBlockSensor",
	humanName="Sensor",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=158.2,
	pcu=25,
	components=mapOf("InteriorPlate" to 5, "Construction" to 5, "Computer" to 6, "RadioCommunication" to 4, "Detector" to 6, "SteelPlate" to 2)
), BlockData(
	typeId="TargetDummyBlock",
	xsiType="TargetDummyBlock",
	subtypeId="TargetDummy",
	humanName="Target Dummy",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=396.8,
	pcu=25,
	components=mapOf("SteelPlate" to 15, "SmallTube" to 10, "Motor" to 2, "Computer" to 4, "Display" to 1)
), BlockData(
	typeId="SoundBlock",
	xsiType="SoundBlock",
	subtypeId="SmallBlockSoundBlock",
	humanName="Sound Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=60.6,
	pcu=25,
	components=mapOf("InteriorPlate" to 4, "Construction" to 6, "Computer" to 3)
), BlockData(
	typeId="SoundBlock",
	xsiType="SoundBlock",
	subtypeId="LargeBlockSoundBlock",
	humanName="Sound Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=60.6,
	pcu=25,
	components=mapOf("InteriorPlate" to 4, "Construction" to 6, "Computer" to 3)
), BlockData(
	typeId="ButtonPanel",
	xsiType="ButtonPanel",
	subtypeId="ButtonPanelLarge",
	humanName="Button Panel",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=194.0,
	pcu=5,
	components=mapOf("InteriorPlate" to 10, "Construction" to 20, "Computer" to 20)
), BlockData(
	typeId="ButtonPanel",
	xsiType="ButtonPanel",
	subtypeId="ButtonPanelSmall",
	humanName="Button Panel",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=22.2,
	pcu=5,
	components=mapOf("InteriorPlate" to 2, "Construction" to 2, "Computer" to 1)
), BlockData(
	typeId="ButtonPanel",
	xsiType="ButtonPanel",
	subtypeId="LargeButtonPanelPedestal",
	humanName="Button Panel Pedestal",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=96.0,
	pcu=5,
	components=mapOf("InteriorPlate" to 5, "Construction" to 10, "Computer" to 5)
), BlockData(
	typeId="ButtonPanel",
	xsiType="ButtonPanel",
	subtypeId="SmallButtonPanelPedestal",
	humanName="Button Panel Pedestal",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 3, 1),
	mass=96.0,
	pcu=5,
	components=mapOf("InteriorPlate" to 5, "Construction" to 10, "Computer" to 5)
), BlockData(
	typeId="TimerBlock",
	xsiType="TimerBlock",
	subtypeId="TimerBlockLarge",
	humanName="Timer Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=259.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 6, "Construction" to 30, "Computer" to 5)
), BlockData(
	typeId="TimerBlock",
	xsiType="TimerBlock",
	subtypeId="TimerBlockSmall",
	humanName="Timer Block",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=30.2,
	pcu=25,
	components=mapOf("InteriorPlate" to 2, "Construction" to 3, "Computer" to 1)
), BlockData(
	typeId="MyProgrammableBlock",
	xsiType="ProgrammableBlock",
	subtypeId="LargeProgrammableBlock",
	humanName="Programmable Block",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=534.4,
	pcu=100,
	components=mapOf("SteelPlate" to 21, "Construction" to 4, "LargeTube" to 2, "Motor" to 1, "Display" to 1, "Computer" to 2)
), BlockData(
	typeId="TurretControlBlock",
	xsiType="TurretControlBlock",
	subtypeId="LargeTurretControlBlock",
	humanName="Custom Turret Controller",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=948.0,
	pcu=100,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "Detector" to 20, "Motor" to 4, "Display" to 6, "Computer" to 20, "SteelPlate" to 20)
), BlockData(
	typeId="TurretControlBlock",
	xsiType="TurretControlBlock",
	subtypeId="SmallTurretControlBlock",
	humanName="Custom Turret Controller",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=250.0,
	pcu=100,
	components=mapOf("InteriorPlate" to 4, "Construction" to 10, "Detector" to 4, "Motor" to 2, "Display" to 1, "Computer" to 10, "SteelPlate" to 4)
), BlockData(
	typeId="EventControllerBlock",
	xsiType="EventControllerBlock",
	subtypeId="EventControllerLarge",
	humanName="Event Controller",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=304.0,
	pcu=10,
	components=mapOf("InteriorPlate" to 10, "Construction" to 30, "Computer" to 10, "Display" to 4)
), BlockData(
	typeId="EventControllerBlock",
	xsiType="EventControllerBlock",
	subtypeId="EventControllerSmall",
	humanName="Event Controller",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=38.4,
	pcu=10,
	components=mapOf("InteriorPlate" to 2, "Construction" to 3, "Computer" to 2, "Display" to 1)
), BlockData(
	typeId="PathRecorderBlock",
	xsiType="PathRecorderBlock",
	subtypeId="LargePathRecorderBlock",
	humanName="AI Recorder (Task)",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=900.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "Detector" to 20, "Motor" to 4, "Computer" to 20, "SteelPlate" to 20)
), BlockData(
	typeId="PathRecorderBlock",
	xsiType="PathRecorderBlock",
	subtypeId="SmallPathRecorderBlock",
	humanName="AI Recorder (Task)",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=156.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 2, "Construction" to 5, "Detector" to 4, "Motor" to 2, "Computer" to 10, "SteelPlate" to 2)
), BlockData(
	typeId="BasicMissionBlock",
	xsiType="BasicMissionBlock",
	subtypeId="LargeBasicMission",
	humanName="AI Basic (Task)",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=900.0,
	pcu=15,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "Detector" to 20, "Motor" to 4, "Computer" to 20, "SteelPlate" to 20)
), BlockData(
	typeId="BasicMissionBlock",
	xsiType="BasicMissionBlock",
	subtypeId="SmallBasicMission",
	humanName="AI Basic (Task)",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=156.0,
	pcu=15,
	components=mapOf("InteriorPlate" to 2, "Construction" to 5, "Detector" to 4, "Motor" to 2, "Computer" to 10, "SteelPlate" to 2)
), BlockData(
	typeId="FlightMovementBlock",
	xsiType="FlightMovementBlock",
	subtypeId="LargeFlightMovement",
	humanName="AI Flight (Move)",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=900.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "Detector" to 20, "Motor" to 4, "Computer" to 20, "SteelPlate" to 20)
), BlockData(
	typeId="FlightMovementBlock",
	xsiType="FlightMovementBlock",
	subtypeId="SmallFlightMovement",
	humanName="AI Flight (Move)",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=156.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 2, "Construction" to 5, "Detector" to 4, "Motor" to 2, "Computer" to 10, "SteelPlate" to 2)
), BlockData(
	typeId="DefensiveCombatBlock",
	xsiType="DefensiveCombatBlock",
	subtypeId="LargeDefensiveCombat",
	humanName="AI Defensive (Combat)",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=900.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "Detector" to 20, "Motor" to 4, "Computer" to 20, "SteelPlate" to 20)
), BlockData(
	typeId="DefensiveCombatBlock",
	xsiType="DefensiveCombatBlock",
	subtypeId="SmallDefensiveCombat",
	humanName="AI Defensive (Combat)",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=156.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 2, "Construction" to 5, "Detector" to 4, "Motor" to 2, "Computer" to 10, "SteelPlate" to 2)
), BlockData(
	typeId="OffensiveCombatBlock",
	xsiType="OffensiveCombatBlock",
	subtypeId="LargeOffensiveCombat",
	humanName="AI Offensive (Combat)",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=900.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 20, "Construction" to 30, "Detector" to 20, "Motor" to 4, "Computer" to 20, "SteelPlate" to 20)
), BlockData(
	typeId="OffensiveCombatBlock",
	xsiType="OffensiveCombatBlock",
	subtypeId="SmallOffensiveCombat",
	humanName="AI Offensive (Combat)",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=156.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 2, "Construction" to 5, "Detector" to 4, "Motor" to 2, "Computer" to 10, "SteelPlate" to 2)
), BlockData(
	typeId="RadioAntenna",
	xsiType="RadioAntenna",
	subtypeId="LargeBlockRadioAntenna",
	humanName="Antenna",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 6, 2),
	mass=3401.6,
	pcu=100,
	components=mapOf("SteelPlate" to 80, "LargeTube" to 40, "SmallTube" to 60, "Construction" to 30, "Computer" to 8, "RadioCommunication" to 40)
), BlockData(
	typeId="Beacon",
	xsiType="Beacon",
	subtypeId="LargeBlockBeacon",
	humanName="Beacon",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=2662.0,
	pcu=50,
	components=mapOf("SteelPlate" to 80, "Construction" to 30, "LargeTube" to 20, "Computer" to 10, "RadioCommunication" to 40)
), BlockData(
	typeId="Beacon",
	xsiType="Beacon",
	subtypeId="SmallBlockBeacon",
	humanName="Beacon",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=84.2,
	pcu=50,
	components=mapOf("SteelPlate" to 2, "Construction" to 1, "SmallTube" to 1, "Computer" to 1, "RadioCommunication" to 4)
), BlockData(
	typeId="RadioAntenna",
	xsiType="RadioAntenna",
	subtypeId="SmallBlockRadioAntenna",
	humanName="Antenna",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 2),
	mass=72.2,
	pcu=100,
	components=mapOf("SteelPlate" to 1, "SmallTube" to 1, "Construction" to 2, "Computer" to 1, "RadioCommunication" to 4)
), BlockData(
	typeId="RemoteControl",
	xsiType="RemoteControl",
	subtypeId="LargeBlockRemoteControl",
	humanName="Remote Control",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 1, 1),
	mass=137.0,
	pcu=25,
	components=mapOf("InteriorPlate" to 10, "Construction" to 10, "Motor" to 1, "Computer" to 15)
), BlockData(
	typeId="RemoteControl",
	xsiType="RemoteControl",
	subtypeId="SmallBlockRemoteControl",
	humanName="Remote Control",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(1, 1, 1),
	mass=38.2,
	pcu=25,
	components=mapOf("InteriorPlate" to 2, "Construction" to 1, "Motor" to 1, "Computer" to 1)
), BlockData(
	typeId="LaserAntenna",
	xsiType="LaserAntenna",
	subtypeId="LargeBlockLaserAntenna",
	humanName="Laser Antenna",
	gridSize=GridSize.LARGE,
	dimensions=BlockSize(1, 2, 1),
	mass=3584.0,
	pcu=100,
	components=mapOf("SteelPlate" to 50, "Construction" to 40, "Motor" to 16, "Detector" to 30, "RadioCommunication" to 20, "Superconductor" to 100, "Computer" to 50, "BulletproofGlass" to 4)
), BlockData(
	typeId="LaserAntenna",
	xsiType="LaserAntenna",
	subtypeId="SmallBlockLaserAntenna",
	humanName="Laser Antenna",
	gridSize=GridSize.SMALL,
	dimensions=BlockSize(3, 3, 3),
	mass=666.0,
	pcu=100,
	components=mapOf("SteelPlate" to 10, "SmallTube" to 10, "Construction" to 10, "Motor" to 5, "RadioCommunication" to 5, "Superconductor" to 10, "Computer" to 30, "BulletproofGlass" to 2)
), )